import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useForm } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import axios from "axios";
import { useGlobalSpinnerActionsContext } from "../../context/GlobalSpinnerContext";
import _ from "lodash";
import OUMapping from "../../assets/data/registerOU";

import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import ReplayIcon from "@mui/icons-material/Replay";

import InfoIcon from "@material-ui/icons/Info";

import Validator from "../validation/validator/validatorStage";
import ShowError from "../validation/showError/ShowError";

import OUFieldConfig from "./OUStageFieldConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faQrcode,
  faTimes,
  faFileUpload,
} from "@fortawesome/free-solid-svg-icons";
import Html5QrcodePlugin from "../html5qrbarcodescanner/Html5QrBarcodeScanner";
import { isEmpty, isString } from "../../helper/index";
import {
  Button,
  ButtonStrip,
  InputFieldFF,
  SingleSelectFieldFF,
  ReactFinalForm,
  SwitchFieldFF,
  hasValue,
  TextAreaFieldFF,
  composeValidators,
  dhis2Username,
  FieldGroupFF,
  CheckboxFieldFF,
  RadioFieldFF,
  MultiSelectFieldFF,
  FileInput,
  FileInputFieldFF,
  CheckboxField,
} from "@dhis2/ui";

import {
  TextField,
  Checkboxes,
  CheckboxData,
  Radios,
  Select,
  TimePicker,
  Switches,
  KeyboardDatePicker,
  DatePicker,
  DateTimePicker,
  Autocomplete,
} from "mui-rff";

import Grid from "@material-ui/core/Grid";

import "date-fns";
import DateFnsUtils from "@date-io/date-fns";

import { apiServices } from "../../services/apiServices";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";

const { Form, Field } = ReactFinalForm;

const getTranslatedLabels = (dataElement) => {
  if (localStorage.getItem("locale") == "en") {
    return dataElement.formName
      ? dataElement.formName
      : dataElement.displayName
      ? dataElement.displayName
      : dataElement.description;
  } else if (dataElement.translations && dataElement.translations.length > 0) {
    let label = dataElement.translations.filter(
      (tanslation) =>
        tanslation.property == "NAME" &&
        tanslation.locale == localStorage.getItem("locale")
    );
    if (label.length > 0) {
      return label[0].value;
    } else {
      return dataElement.formName
        ? dataElement.formName
        : dataElement.displayName
        ? dataElement.displayName
        : dataElement.description;
    }
  }
  return dataElement.formName
    ? dataElement.formName
    : dataElement.displayName
    ? dataElement.displayName
    : dataElement.description;
};

const checkDisabledField = ({
  hivarray,
  fieldData,
  hivConditions,
  AllHIVConditionCheck,
}) => {
  let isDisabled = false;
  const reactiveGroup = hivarray.filter((h) => h.group.includes("reactive"));
  const positiveGroup = hivarray.filter((h) => h.group.includes("positive"));
  const artGroup = hivarray.filter((h) => h.group.includes("art"));

  const reactiveMatchedField = reactiveGroup.find(
    (field) => field.id === fieldData.dataElement.id && field.status
  );
  if (reactiveMatchedField) {
    if (hivConditions.reactive) {
      isDisabled = true;
    }
  }

  const positiveMatchedField = positiveGroup.find(
    (field) => field.id === fieldData.dataElement.id && field.status
  );
  if (positiveMatchedField) {
    if (hivConditions.positive) {
      isDisabled = true;
    }
  }

  const artMatchedField = artGroup.find(
    (field) => field.id === fieldData.dataElement.id && field.status
  );
  if (artMatchedField) {
    if (hivConditions.art) {
      isDisabled = true;
    }
  }

  if (AllHIVConditionCheck) {
    isDisabled = true;
  }

  return isDisabled;
};

function InputFieldConfig(props) {
  const { t } = useTranslation();
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let dataElementGroup = props.dataElementGroup;
  let customfieldobj = props.customfieldobj;
  let customClassName = props.customClassName;
  let symptomsFID = props.symptomsFID;
  let Configuration = props.Configuration;
  let currentStage = props.currentStage;
  let isDisabled = false;
  let hivarray = props.hivarray;
  const hivConditions = props.hivConditions;
  let AllHIVConditionCheck = props.AllHIVConditionCheck;
  const form = useForm();
  let formref = props.formref;

  const [defaultValue, setDefaultValue] = useState(null);

  const [fieldType, setFieldType] = useState(null);
  const [optionSet, setOptions] = useState(null);
  const [icons, setIcons] = useState(null);
  const [fieldStructure, setFieldStructure] = useState(null);
  const [validationResult, setValidationResult] = useState(null);
  let iscompulsory = false;
  let OUJSON = props.OUJSON.organisationUnits;
  let orgid = props.programorgid;
  const required = (value) =>
    fieldData.compulsory && validationResult.hideShow == true
      ? value
        ? undefined
        : t("Required")
      : undefined;

  const scriptCheck = (value) =>
    value
      ? value.match(/<[^>]*>/g) != null
        ? t('Incorrect expression "< or >" added as input')
        : undefined
      : undefined;
  const composeValidators =
    (...validators) =>
    (value) =>
      validators.reduce(
        (error, validator) => error || validator(value),
        undefined
      );

  const checkboxDependent = [
    //uat
    {
      dependentField: [customfieldobj.testingforTBinfectionID],
      option: customfieldobj.noneOptionID,
    },
  ];
  function checkHideOptionsFields(
    attributes,
    programRules,
    programRulesVariables,
    values
  ) {
    const fieldId = attributes.dataElement.id;
    let option = [];
    let filteringRuleWithField = null;

    programRules.map((rules) => {
      filteringRuleWithField = rules.programRuleActions.filter((obj) =>
        obj.dataElement ? fieldId == obj.dataElement.id : undefined
      );

      if (
        filteringRuleWithField.length > 0 &&
        filteringRuleWithField[0].programRuleActionType == "HIDEOPTION"
      ) {
        const operators = ["==", "!="];
        const condition = rules.condition;
        const splitConditions = condition.split("&&");
        let Flag = null;
        let val = null;
        let conditionArray = [];
        splitConditions.map((splitCondition) => {
          const variableName = splitCondition.match(/\{(.*?)\}/)[1];
          const parentRaw = programRulesVariables.filter(
            (obj) => obj.displayName == splitCondition.match(/\{(.*?)\}/)[1]
          ); //[0] .dataElement.id
          const parentNameFromFilter =
            parentRaw.length > 0 ? parentRaw[0].displayName : undefined;
          const parentId =
            parentRaw.length > 0
              ? parentRaw[0].dataElement
                ? parentRaw[0].dataElement.id
                : parentRaw[0].trackedEntityAttribute
                ? parentRaw[0].trackedEntityAttribute.id
                : undefined
              : undefined;

          const parentNameFromFilterStart =
            splitCondition.search(parentNameFromFilter);
          const parentNameLength = parentNameFromFilter
            ? parentNameFromFilter.length
            : undefined;

          const operatorInitLength =
            parentNameFromFilterStart + parentNameLength + 2;

          const operator = splitCondition.substring(
            operatorInitLength,
            operatorInitLength + 2
          );

          const alternateOperatorFinding = operators.map((ops) => {
            if (splitCondition.search(ops) > -1) {
              const a = {
                operator: ops,
                operatorLength: splitCondition.search(ops),
              };
              return a;
            }
          });
          const stringLength = splitCondition.length;
          if (parentNameFromFilter) {
            const filteredOperator = alternateOperatorFinding.filter(
              (obj) => obj != undefined
            );

            const conditionValueRaw =
              filteredOperator.length > 0
                ? splitCondition.substring(
                    filteredOperator[0].operatorLength + 3,
                    splitCondition.length
                  )
                : undefined;

            const removeEmptySpace =
              conditionValueRaw != undefined
                ? conditionValueRaw.substring(
                    conditionValueRaw.length - 1,
                    conditionValueRaw.length
                  ) == " "
                  ? conditionValueRaw.substring(0, conditionValueRaw.length - 1)
                  : conditionValueRaw
                : undefined;

            const conditionValue =
              removeEmptySpace != undefined
                ? removeEmptySpace.substring(1, removeEmptySpace.length - 1)
                : undefined;
            const conditionalOperator =
              filteredOperator.length > 0
                ? filteredOperator[0].operator
                : undefined;
            let conditionForValidation = null;
            if (conditionalOperator != undefined) {
              val = conditionValue;
              switch (conditionalOperator) {
                case "==":
                  if (
                    values[parentId] != undefined &&
                    String(values[parentId]) == String(conditionValue)
                  ) {
                    filteringRuleWithField.map((optionHideRule) => {
                      attributes.dataElement.optionSet.options.map(
                        (options) => {
                          if (options.id != optionHideRule.option.id) {
                            if (option.length > 0) {
                              let checkOptionInArray = option.find(
                                (obj) => obj.id == options.id
                              );
                              if (checkOptionInArray == undefined) {
                                option.push(options);
                              }
                            } else {
                              option.push(options);
                            }
                          } else {
                            var temp = {
                              id: options.id,
                              code: options.code,
                              displayName: null,
                            };

                            let checkOptionInArray = option.find(
                              (obj) => obj.id == temp.id
                            );

                            if (checkOptionInArray == undefined) {
                              option.push(temp);
                            }
                          }
                        }
                      );
                    });
                  }
                  break;

                case ">=":
                  if (
                    values[parentId] != undefined &&
                    Number(values[parentId]) >= Number(conditionValue)
                  ) {
                    filteringRuleWithField.map((optionHideRule) => {
                      attributes.dataElement.optionSet.options.map(
                        (options) => {
                          if (options.id != optionHideRule.option.id) {
                            option.push(options);
                          } else {
                            var temp = {
                              id: options.id,
                              code: options.code,
                              displayName: null,
                            };
                            option.push(temp);
                          }
                        }
                      );
                    });
                  }
                  break;

                case "<=":
                  if (
                    values[parentId] != undefined &&
                    Number(values[parentId]) <= Number(conditionValue)
                  ) {
                    filteringRuleWithField.map((optionHideRule) => {
                      attributes.dataElement.optionSet.options.map(
                        (options) => {
                          if (options.id != optionHideRule.option.id) {
                            option.push(options);
                          } else {
                            var temp = {
                              id: options.id,
                              code: options.code,
                              displayName: null,
                            };
                            option.push(temp);
                          }
                        }
                      );
                    });
                  }
                  break;

                case "<":
                  if (
                    values[parentId] != undefined &&
                    Number(values[parentId]) < Number(conditionValue)
                  ) {
                    filteringRuleWithField.map((optionHideRule) => {
                      attributes.dataElement.optionSet.options.map(
                        (options) => {
                          if (options.id != optionHideRule.option.id) {
                            option.push(options);
                          } else {
                            var temp = {
                              id: options.id,
                              code: options.code,
                              displayName: null,
                            };
                            option.push(temp);
                          }
                        }
                      );
                    });
                  }
                  break;

                case ">":
                  if (
                    values[parentId] != undefined &&
                    Number(values[parentId]) > Number(conditionValue)
                  ) {
                    filteringRuleWithField.map((optionHideRule) => {
                      attributes.dataElement.optionSet.options.map(
                        (options) => {
                          if (options.id != optionHideRule.option.id) {
                            option.push(options);
                          } else {
                            var temp = {
                              id: options.id,
                              code: options.code,
                              displayName: null,
                            };
                            option.push(temp);
                          }
                        }
                      );
                    });
                  }
                  break;
              }
            }
          }
        });
      }
    });

    if (option.length > 0) {
      return option;
    } else {
      return attributes.dataElement.optionSet.options;
    }
  }

  function findFieldType() {
    const dataElement = fieldData.dataElement;
    if (dataElement.optionSet != undefined) {
      if (
        fieldData.renderOptionsAsRadio ||
        (fieldData.renderType &&
          fieldData.renderType["DESKTOP"] &&
          fieldData.renderType["DESKTOP"].type &&
          fieldData.renderType["DESKTOP"].type == "HORIZONTAL_RADIOBUTTONS")
      ) {
        setFieldType("radio");
      } else {
        if (fieldData.renderType) {
          if (fieldData.renderType.DESKTOP) {
            if (fieldData.renderType.DESKTOP.type == "ICONS_AS_BUTTONS") {
              setFieldType("radio");
            } else {
              setFieldType("dropdown");
            }
          }
        }
      }
    } else {
      setFieldType("text");
    }
  }

  function fetchOption() {
    let output = [];
    const dataElement = fieldData.dataElement;

    if (dataElement.optionSet != undefined) {
      const selectedParentValue = values["q9zXRCjQa67"];
      const rule = Configuration.additionalService.find(
        (r) => r.id === selectedParentValue
      );

      const selectedRefParentValue =
        values[customfieldobj.refneededforserviceId];
      const refRule = Configuration.additionalService.find(
        (r) => r.id === selectedRefParentValue
      );

      if (
        rule &&
        fieldData.dataElement.formName ===
          "Referral Needed for Which Service" &&
        fieldData.dataElement.optionSet !== undefined
      ) {
        const refinedOptionList = checkHideOptionsFields(
          fieldData,
          programRules,
          programRulesVariables,
          values
        );

        output = refinedOptionList
          .filter((item) => rule.child.includes(item.code))
          .map((item) => ({
            value: item.code,
            id: item.id,
            label: getTranslatedLabels(item),
          }));
        const valueExists = output.some(
          (obj) => obj.value === values[fieldData.dataElement.id]
        );
        if (!valueExists) {
          delete values[fieldData.dataElement.id];

          const bmizInput = document.getElementById("FoiiruViif7");
        }
      } else if (
        refRule &&
        fieldData.dataElement.formName === "Availed Service" &&
        fieldData.dataElement.optionSet !== undefined
      ) {
        const refinedOptionList = checkHideOptionsFields(
          fieldData,
          programRules,
          programRulesVariables,
          values
        );

        output = refinedOptionList
          .filter((item) => refRule.child.includes(item.code))
          .map((item) => ({
            value: item.code,
            id: item.id,
            label: getTranslatedLabels(item),
          }));
        const valueExists = output.some(
          (obj) => obj.value === values[fieldData.dataElement.id]
        );
        if (!valueExists) {
          delete values[fieldData.dataElement.id];
        }
      } else if (
        fieldData.dataElement.formName ===
          "Referral Needed for Which Service" ||
        fieldData.dataElement.formName === "Availed Service"
      ) {
        output = [];
      } else {
        let refinedOptionList = checkHideOptionsFields(
          fieldData,
          programRules,
          programRulesVariables,
          values
        );
        // console.log("refinedOptionList", refinedOptionList)
        refinedOptionList.map((items, index) => {
          if (icons.length > 0) {
            output.push({
              value: items.code,
              id: items.id,
              label: (
                <>
                  {" "}
                  <span
                    dangerouslySetInnerHTML={{ __html: icons[index] }}
                  />{" "}
                  <>{getTranslatedLabels(items)} </>{" "}
                </>
              ),
            });
          } else {
            output.push({
              value: items.code,
              id: items.id,
              label: getTranslatedLabels(items),
            });
          }
        });
      }
      if (fieldData.dataElement.id == customfieldobj.refneededforserviceId) {
        const isDifferent =
          JSON.stringify(output) !== JSON.stringify(optionSet);
        if (isDifferent) {
          delete values["FoiiruViif7"];

          const state = formref.current.getFieldState("FoiiruViif7");

          if (state) {
            formref.current.focus("FoiiruViif7"); // focus field
            setTimeout(() => {
              formref.current.blur("FoiiruViif7"); // trigger validation
            }, 0); // small delay allows DOM to update
          }
        }
      }
      setOptions(output);
    }
  }

  function getIcons() {
    let promises = [];
    const dataElement = fieldData.dataElement;
    if (navigator.onLine) {
      if (dataElement.optionSet != undefined) {
        dataElement.optionSet.options.forEach((options) => {
          if (options.style != undefined) {
            const getIconApi = "icons/" + options.style.icon + "/icon.svg";
            promises.push(apiServices.getAPI(getIconApi));
          } else {
            promises.push({});
          }
        });

        Promise.all(promises).then((responses) => {
          const icons = responses.map((response) => response.data);

          if (icons.length > 0) {
            setIcons(icons);
          } else {
            setIcons([]);
          }
        });
      } else {
        setIcons([]);
      }
    } else {
      setIcons([]);
    }
  }

  function fetchValidation() {
    const validationResult = Validator(
      fieldData.dataElement.id,
      fieldData,
      values,
      programRules,
      programRulesVariables,
      dataElementGroup
    );
    setValidationResult(validationResult);
  }

  useEffect(() => {
    getIcons();
  }, []);

  useEffect(() => {
    if (Array.isArray(icons)) {
      findFieldType();
      fetchOption();
      fetchValidation();
    }
  }, [icons, values, localStorage.getItem("locale")]);

  useEffect(() => {
    if (
      fieldType == "dropdown" &&
      currentStage.description == "General Services"
    ) {
      setDefaultValue("Yes"); // ✅ State updates inside useEffect
    }
  }, [fieldType, currentStage]);

  useEffect(() => {
    if (validationResult != null && fieldType != null) {
      let customProps = { className: customClassName };
      try {
        checkboxDependent.map((o) => {
          if (o.dependentField.includes(fieldData.dataElement.id)) {
            //for symptoms
            customProps = { ...customProps, className: "hide" };
            if (values[o.option]) {
              if (
                values[customfieldobj.CXRreportavailableID] &&
                (values[customfieldobj.CXRreportavailableID] == "No" ||
                  (values[customfieldobj.CXRresultId] &&
                    values[customfieldobj.CXRresultId] ==
                      "Not suggestive of TB")) &&
                values[customfieldobj.mWRDreportavailableID] &&
                (values[customfieldobj.mWRDreportavailableID] == "No" ||
                  (values[customfieldobj.mWRDresultId] &&
                    values[customfieldobj.mWRDresultId] == "Negative"))
              ) {
                //customProps = { ...customProps, className: "" };
                if (
                  !values[customfieldobj.hivStatusId] ||
                  values[customfieldobj.hivStatusId] != "Positive" ||
                  (values[customfieldobj.hivStatusId] &&
                    values[customfieldobj.hivStatusId] == "Positive" &&
                    values[customfieldobj.CRPreportavailableID] &&
                    (values[customfieldobj.CRPreportavailableID] == "No" ||
                      (values[customfieldobj.CRPresultId] &&
                        values[customfieldobj.CRPresultId] == "Negative")))
                ) {
                  customProps = { ...customProps, className: "" };
                }
              }
            } else {
            }
          }
        });
      } catch (e) {}
      if (fieldType == "text") {
        let defaultFieldValue = "";
        if (fieldData.dataElement.fieldMask == "Default Facility") {
          let facility = OUJSON.filter((obj) => obj.id == orgid);
          defaultFieldValue = facility && facility[0] ? facility[0].name : "";
        }

        if (currentStage.description == "General Services") {
          customClassName = "gstabletext";
        }

        const matchingRule = Configuration.validationRule.find((rule) => {
          const isChild = rule.child === fieldData.dataElement.id;
          const actualValue = values[rule.id];
          const expectedValue = rule.value;
          const valueMismatch = actualValue !== expectedValue;

          return isChild && valueMismatch;
        });

        if (matchingRule) {
          isDisabled = matchingRule.isDisabled;
        }

        if (
          fieldData.dataElement.id == "g8VD210xr6b" ||
          fieldData.dataElement.id == "ed59J56iD2N" ||
          fieldData.dataElement.id == "RDsUVdm8LfB"
        ) {
          if (!isDisabled) fieldData.compulsory = true;
          else fieldData.compulsory = false;
        }

        const mandatoryRule = Configuration?.mandatoryRule.find((rule) => {
          const isChild = rule.child === fieldData.dataElement.id;
          const actualValue = values[rule.id];
          const expectedValue = rule.value;
          const valueMismatch = actualValue === expectedValue;

          return isChild && valueMismatch;
        });

        if (mandatoryRule) {
          fieldData.compulsory = mandatoryRule.isMandatory;
        }

        if (
          fieldData.dataElement.id == customfieldobj.reffacnameId &&
          !values[customfieldobj.refneededforserviceId]
        ) {
          validationResult.hideShow = false;
        }

        const matchedField = hivarray.find(
          (field) => field.id === fieldData.dataElement.id && field.status
        );

        if (matchedField) {
          isDisabled = checkDisabledField({
            hivarray,
            fieldData,
            hivConditions,
            AllHIVConditionCheck,
          });

          values[fieldData.dataElement.id] = values[fieldData.dataElement.id]
            ? values[fieldData.dataElement.id]
            : matchedField?.value;
        }

        if (
          fieldData.dataElement.id == customfieldobj.BPRefFacNameId &&
          values["avBFSwD48pv"] != "Yes"
        ) {
          validationResult.hideShow = false;
        } else if (
          fieldData.dataElement.id == customfieldobj.BPRefFacNameId &&
          values["avBFSwD48pv"] == "Yes"
        ) {
          validationResult.hideShow = true;
          const state = formref.current.getFieldState(fieldData.dataElement.id);

          if (state) {
            formref.current.focus(fieldData.dataElement.id); // focus field
            setTimeout(() => {
              formref.current.blur(fieldData.dataElement.id); // trigger validation
            }, 0); // small delay allows DOM to update
          }
        }

        if (fieldData.dataElement.id == customfieldobj.eyedetailofissueId) {
          if (values[customfieldobj.eyeissueidentified] == "No") {
            values[customfieldobj.eyedetailofissueId] = "";
          }
        }

        const isFieldHidden = (fieldData) => {
          // Replace this with your actual logic to determine if the field should be hidden
          return fieldData.hide || validationResult?.hideShow === false;
        };

        if (validationResult.hideShow == false) {
          values[fieldData.dataElement.id] = "";
        }

        if (
          fieldData.dataElement.id == customfieldobj.placeofconfirmationhivId
        ) {
          if (!values[customfieldobj.hivreferforconfirmationId]) {
            validationResult.hideShow = false;
          }
        }

        setFieldStructure(
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            className={validationResult.hideShow == true ? "" : "hide"}
          >
            <Field
              name={fieldData.dataElement.id}
              key={`${fieldData.dataElement.id}-${validationResult.hideShow}`}
              label={
                customProps?.tooltip ? (
                  <div>
                    {currentStage.description !== "General Services" &&
                    currentStage.name !==
                      "NCDs Screening, Treatment and Linkages"
                      ? getTranslatedLabels(fieldData.dataElement)
                      : ""}
                    {customProps?.tooltip && (
                      <Tooltip
                        title={customProps.tooltipDesc}
                        placement="top"
                        enterTouchDelay={0}
                        leaveTouchDelay={5000}
                        arrow
                      >
                        <IconButton
                          aria-label="info"
                          size="small"
                          style={{ padding: 0, marginLeft: 4 }}
                        >
                          <InfoIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                ) : currentStage.description !== "General Services" &&
                  currentStage.name !==
                    "NCDs Screening, Treatment and Linkages" ? (
                  getTranslatedLabels(fieldData.dataElement)
                ) : (
                  ""
                )
              }
              type="text"
              component={InputFieldFF}
              // key={fieldData.dataElement.id}
              defaultValue={defaultFieldValue}
              required={fieldData.compulsory}
              validate={
                !isFieldHidden(fieldData)
                  ? composeValidators(required, scriptCheck)
                  : undefined
              }
              className={customClassName}
              disabled={isDisabled}
            />
          </Grid>
        );
      } else if (fieldType == "radio") {
        if (
          fieldData.dataElement.id == customfieldobj.referfortbId &&
          values[customfieldobj.foundtbsymptomId] == "Yes"
        ) {
          fieldData.compulsory = true;
        } else if (
          fieldData.dataElement.id == customfieldobj.referfortbId &&
          values[customfieldobj.foundtbsymptomId] == "No"
        ) {
          fieldData.compulsory = false;
        }

        if (fieldData.dataElement.id == customfieldobj.drugbyinjectionId) {
          customProps = {
            ...customProps,
            disabled: true,
            tooltip: true,
            tooltipDesc: t("NON-MEDICAL USE ONLY"),
          };
        }

        const matchingRule = Configuration.validationRule.find((rule) => {
          const isChild = rule.child === fieldData.dataElement.id;
          const actualValue = values[rule.id];
          const expectedValue = rule.value;
          const valueMismatch = actualValue !== expectedValue;

          return isChild && valueMismatch;
        });

        if (matchingRule) {
          isDisabled = matchingRule.isDisabled;
        }

        setFieldStructure(
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            className={
              validationResult.hideShow == true ? customClassName : "hide"
            }
          >
            <Radios
              id={fieldData.dataElement.id}
              label={
                customProps?.tooltip ? (
                  <div>
                    {getTranslatedLabels(fieldData.dataElement)}
                    <Tooltip
                      title={customProps.tooltipDesc}
                      placement="top"
                      enterTouchDelay={0}
                      leaveTouchDelay={5000}
                      arrow
                    >
                      <IconButton
                        aria-label="info"
                        size="small"
                        style={{ padding: 0, marginLeft: 4 }}
                      >
                        <InfoIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                ) : (
                  getTranslatedLabels(fieldData.dataElement)
                )
              }
              name={fieldData.dataElement.id}
              required={
                fieldData.compulsory && validationResult.hideShow == true
                  ? true
                  : false
              }
              data={optionSet != null ? optionSet : []}
              className={customClassName}
              disabled={isDisabled}
            />
          </Grid>
        );
      } else if (fieldType == "dropdown") {
        // console.log("dropdown",values, values[fieldData.dataElement.id],fieldData.dataElement.id)
        // if(fieldData.dataElement.id == "vYCSpTwJqr5") {
        //   values["vYCSpTwJqr5"] = "No"
        // }

        const onDropdownOptionChange = (dataElement, selectedValue) => {
          // console.log("Element:", dataElement);
          // console.log("Changed to:", selectedValue);
          // You can now determine the next logic step here without altering field behavior
        };

        try {
          if (currentStage.description == "General Services") {
            customClassName = "gstabledropdown";
          }
        } catch (e) {}
        try {
          if (values[fieldData.dataElement.id]) {
            let isValueExist = true;
            isValueExist = optionSet.find(
              (obj) => obj.value == values[fieldData.dataElement.id]
            );
            // console.log("isValueExist", isValueExist)
            if (isValueExist == undefined) {
              delete values[fieldData.dataElement.id];
            }
          }
        } catch (e) {}

        const matchingRule = Configuration.validationRule.find((rule) => {
          const isChild = rule.child === fieldData.dataElement.id;
          const actualValue = values[rule.id];
          const expectedValue = rule.value;
          const valueMismatch = actualValue !== expectedValue;
          return isChild && valueMismatch;
        });

        if (matchingRule) {
          isDisabled = matchingRule.isDisabled;
        }

        const mandatoryRule = Configuration?.mandatoryRule.find((rule) => {
          const isChild = rule.child === fieldData.dataElement.id;
          const actualValue = values[rule.id];
          const expectedValue = rule.value;
          const valueMismatch = actualValue === expectedValue;

          return isChild && valueMismatch;
        });

        if (mandatoryRule) {
          iscompulsory = mandatoryRule.isMandatory;
        }

        if (
          fieldData.dataElement.id == "yqQYUaaJQdq" ||
          fieldData.dataElement.id == "WVg1XRuWBAA"
        ) {
          if (values[customfieldobj.coworkerId]) {
            iscompulsory = true;
            isDisabled = false;
          } else if (values[customfieldobj.PaidId]) {
            iscompulsory = true;
            isDisabled = false;
          } else if (values[customfieldobj.LoverId]) {
            iscompulsory = true;
            isDisabled = false;
          } else if (values[customfieldobj.OtherSexPartnerId]) {
            iscompulsory = true;
            isDisabled = false;
          } else {
            iscompulsory = false;
            isDisabled = true;
          }
        }

        const isFieldHidden = (fieldData) => {
          // Replace this with your actual logic to determine if the field should be hidden
          return fieldData.hide || validationResult?.hideShow === false;
        };

        if (fieldData.dataElement.id == customfieldobj.TypeOfServiceId) {
          customProps = {
            ...customProps,
            disabled: true,
            tooltip: true,
            tooltipDesc: t("Information/Counseling/Health Referral etc."),
          };
        }

        if (fieldData.dataElement.id == customfieldobj.refneededforserviceId) {
          if (optionSet.length == 0) {
            validationResult.hideShow = false;
            delete values[customfieldobj.refneededforserviceId];
          }
        }

        if (
          fieldData.dataElement.id == customfieldobj.additionalavailedserviceId
        ) {
          if (optionSet.length == 0) {
            validationResult.hideShow = false;
            delete values[customfieldobj.qFZSDy6VNN6];
          }
        }

        const matchedField = hivarray.find(
          (field) => field.id === fieldData.dataElement.id && field.status
        );

        if (matchedField) {
          isDisabled = checkDisabledField({
            hivarray,
            fieldData,
            hivConditions,
            AllHIVConditionCheck,
          });
          values[fieldData.dataElement.id] = values[fieldData.dataElement.id]
            ? values[fieldData.dataElement.id]
            : matchedField?.value;
        }

        const handleChange = (value) => {
          // console.log("Selected value:", value);
          // Call the parent function with appropriate parameters
          // onValueChange(fieldData.dataElement, value);
        };

        const shouldValidate =
          !isFieldHidden(fieldData) &&
          (iscompulsory || fieldData.compulsory) &&
          validationResult.hideShow === true;

        if (validationResult.hideShow == false) {
          values[fieldData.dataElement.id] = "";
        }

        if (
          fieldData.dataElement.id ==
          customfieldobj.resultofconfirmatorytesthivId
        ) {
          if (!values[customfieldobj.hivreferforconfirmationId]) {
            validationResult.hideShow = false;
          }
        }

        //remove the selected/entered value, if field is disabled
        // if (isDisabled) {
        //   form.change(fieldData.dataElement.id, "");
        // }
        setFieldStructure(
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            {...customProps}
            className={validationResult.hideShow === true ? "" : "hide"}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              {/* Field Wrapper */}
              <div style={{ flex: 1 }}>
                {optionSet?.length > 0 && (
                  <Field
                    id={fieldData.dataElement.id}
                    name={fieldData.dataElement.id}
                    label={
                      customProps?.tooltip ? (
                        <>
                          <span>
                            {getTranslatedLabels(fieldData.dataElement)}
                          </span>
                          <Tooltip
                            title={customProps.tooltipDesc}
                            placement="top"
                          >
                            <IconButton aria-label="info" size="small">
                              <InfoIcon />
                            </IconButton>
                          </Tooltip>
                        </>
                      ) : currentStage.description !== "General Services" &&
                        currentStage.name !==
                          "NCDs Screening, Treatment and Linkages" ? (
                        getTranslatedLabels(fieldData.dataElement)
                      ) : (
                        ""
                      )
                    }
                    // defaultValue={defaultValue}
                    component={SingleSelectFieldFF}
                    key={`${fieldData.dataElement.id}-${validationResult.hideShow}`}
                    validate={shouldValidate ? hasValue : undefined}
                    onChange={handleChange}
                    required={
                      (iscompulsory || fieldData.compulsory) &&
                      validationResult.hideShow === true
                    }
                    options={optionSet || []}
                    disabled={
                      (Array.isArray(fieldData.dataElement?.attributeValues) &&
                        fieldData.dataElement.attributeValues.length > 0 &&
                        fieldData.dataElement.attributeValues[0]?.attribute
                          ?.name === "isDisabled") ||
                      isDisabled
                    }
                    className={customClassName}
                  />
                )}
              </div>

              {/* Reset Button */}
              <Tooltip title="Reset Selection">
                <IconButton
                  onClick={() => form.change(fieldData.dataElement.id, "")}
                  aria-label="reset"
                  size="small"
                  style={{ padding: 3 }}
                  disabled={isDisabled}
                >
                  <ReplayIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </div>
          </Grid>
        );
      }
    }
  }, [
    fieldType,
    defaultValue,
    optionSet,
    validationResult,
    localStorage.getItem("locale"),
  ]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function DateFieldConfig(props) {
  let hivarray = props.hivarray;
  const hivConditions = props.hivConditions;
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let currentStage = props.currentStage;
  let customClassName = props.customClassName;
  let dataElementGroup = props.dataElementGroup;
  let customfieldobj = props.customfieldobj;
  let configuration = props.configuration;
  let AllHIVConditionCheck = props.AllHIVConditionCheck;
  let dateDependencies = props.dateDependencies;
  let hivBehavioural = props.hivBehavioural;
  const activeAccordion = props.activeAccordion;
  let isDisabled = false;
  let formref = props.formref;
  let showYear =
    fieldData.dataElement.attributeValues.length > 0 &&
    fieldData.dataElement.attributeValues[0].attribute.name == "showyear"
      ? true
      : false;
  let hideField =
    fieldData.dataElement.attributeValues.length > 0 &&
    fieldData.dataElement.attributeValues[0].attribute.name == "hideField"
      ? true
      : false;
  const form = useForm();
  const [fieldStructure, setFieldStructure] = useState(null);
  const [selectedDate, setDate] = useState(new Date());
  const [validationResult, setValidationResult] = useState(null);
  const requiredError = fieldData.compulsory
    ? values[fieldData.dataElement.id] == null ||
      values[fieldData.dataElement.id] == undefined
    : "";
  const helperText =
    fieldData.compulsory && requiredError ? "Input is required" : undefined;
  function fetchValidation() {
    const validationResult = Validator(
      fieldData.dataElement.id,
      fieldData,
      values,
      programRules,
      programRulesVariables,
      dataElementGroup
    );
    setValidationResult(validationResult);
  }
  let minDate = "";
  const requiredDate = (value) => (value ? undefined : "Date is required");

  useEffect(() => {
    fetchValidation();
  }, [values]);

  useEffect(() => {
    const matchingRule = configuration.validationRule.find((rule) => {
      const isChild = rule.child === fieldData.dataElement.id;
      const actualValue = values[rule.id];
      const expectedValue = rule.value;
      const valueMismatch = actualValue !== expectedValue;
      return isChild && valueMismatch;
    });

    if (matchingRule) {
      isDisabled = matchingRule.isDisabled;
    }

    if (validationResult != null) {
      const matchedField = hivarray.find(
        (field) => field.id === fieldData.dataElement.id && field.status
      );

      if (matchedField) {
        isDisabled = checkDisabledField({
          hivarray,
          fieldData,
          hivConditions,
          AllHIVConditionCheck,
        });
        values[fieldData.dataElement.id] = values[fieldData.dataElement.id]
          ? values[fieldData.dataElement.id]
          : matchedField?.value;
      }

      if (
        currentStage.description == "General Services" ||
        currentStage.name == "NCDs Screening, Treatment and Linkages"
      ) {
        customClassName = "gstabledate";
      }

      if (
        (fieldData.dataElement.id == customfieldobj.addRefDate ||
          fieldData.dataElement.id == customfieldobj.serviceAvailedDate) &&
        !values[customfieldobj.refneededforserviceId]
      ) {
        validationResult.hideShow = false;
      }

      if (
        fieldData.dataElement.id == customfieldobj.DateofAccessingServiceId ||
        fieldData.dataElement.id ==
          customfieldobj.dateoflifestyleassessmentId ||
        fieldData.dataElement.id ==
          customfieldobj.dateofsexualbehaviourassessmentId ||
        fieldData.dataElement.id == customfieldobj.dateofhivId ||
        fieldData.dataElement.id == customfieldobj.dateoftbscreeningId ||
        fieldData.dataElement.id == customfieldobj.dateofstiscreeningId ||
        fieldData.dataElement.id == customfieldobj.dateofsyphilisscreeningId ||
        fieldData.dataElement.id == customfieldobj.dateofhepCscreeningId ||
        fieldData.dataElement.id == customfieldobj.dateofhepBscreeningId ||
        fieldData.dataElement.id == customfieldobj.dateoflinkagetoserviceId ||
        fieldData.dataElement.id ==
          customfieldobj.dateofservicesocialwelfareId ||
        fieldData.dataElement.id == customfieldobj.dateofservicefamilyId ||
        fieldData.dataElement.id == customfieldobj.dateofbpscreeningId ||
        fieldData.dataElement.id == customfieldobj.dateofpulsescreeningId ||
        fieldData.dataElement.id == customfieldobj.dateofeyescreeningId ||
        fieldData.dataElement.id ==
          customfieldobj.dateoforaldentalscreeningId ||
        fieldData.dataElement.id == customfieldobj.dateofdiabetesscreeningId ||
        fieldData.dataElement.id ==
          customfieldobj.dateofchronicpainscreeningId ||
        fieldData.dataElement.id == customfieldobj.dateofsleepscreeningId ||
        fieldData.dataElement.id ==
          customfieldobj.dateofmentalhealthsscreeningId ||
        fieldData.dataElement.id ==
          customfieldobj.dateofrespiratoryscreeningId ||
        fieldData.dataElement.id == customfieldobj.dateofstomachscreeningId ||
        fieldData.dataElement.id == customfieldobj.dateofotherncdscreeningId ||
        fieldData.dataElement.id == customfieldobj.dateofserviceaddId
      ) {
        //if(!values[fieldData.dataElement.id]) {
        minDate = values[customfieldobj.clientregdateId]
          ? new Date(values[customfieldobj.clientregdateId])
          : undefined; // fallback if it's undefined)
        //}
      }

      if (fieldData.dataElement.id == customfieldobj.dateofconfirmationhivId) {
        if (values[customfieldobj.dateofhivId]) {
          minDate = values[customfieldobj.dateofhivId];
        } else {
          isDisabled = true;
        }
      }

      if (fieldData.dataElement.id == customfieldobj.artlinkdateId) {
        if (values[customfieldobj.dateofconfirmationhivId])
          minDate = values[customfieldobj.dateofconfirmationhivId];
        else isDisabled = true;
      }

      if (fieldData.dataElement.id == customfieldobj.dateoftbtestId) {
        if (values[customfieldobj.dateoftbscreeningId])
          minDate = values[customfieldobj.dateoftbscreeningId];
        else isDisabled = true;
      }

      if (
        fieldData.dataElement.id == customfieldobj.dateoftreatmentinitiationId
      ) {
        if (values[customfieldobj.dateoftbtestId])
          minDate = values[customfieldobj.dateoftbtestId];
        else isDisabled = true;
      }

      if (
        fieldData.dataElement.id ==
        customfieldobj.dateofsyphilistreatmentinitiationId
      ) {
        if (values[customfieldobj.dateofsyphilisscreeningId])
          minDate = values[customfieldobj.dateofsyphilisscreeningId];
        else isDisabled = true;
      }

      if (
        fieldData.dataElement.id ==
        customfieldobj.dateofhepBtreatmentinitiationId
      ) {
        if (values[customfieldobj.dateofhepBscreeningId])
          minDate = values[customfieldobj.dateofhepBscreeningId];
        else isDisabled = true;
      }

      if (
        fieldData.dataElement.id ==
        customfieldobj.dateofhepBtreatmentcompletionId
      ) {
        if (values[customfieldobj.dateofhepBtreatmentinitiationId])
          minDate = values[customfieldobj.dateofhepBtreatmentinitiationId];
        else isDisabled = true;
      }

      if (
        fieldData.dataElement.id ==
        customfieldobj.dateofhepCtreatmentinitiationId
      ) {
        if (values[customfieldobj.dateofhepCscreeningId])
          minDate = values[customfieldobj.dateofhepCscreeningId];
        else isDisabled = true;
      }

      if (
        fieldData.dataElement.id ==
        customfieldobj.dateofhepCtreatmentcompletionId
      ) {
        if (values[customfieldobj.dateofhepCtreatmentinitiationId])
          minDate = values[customfieldobj.dateofhepCtreatmentinitiationId];
        else isDisabled = true;
      }

      if (fieldData.dataElement.id == customfieldobj.dateofserviceavailedId) {
        if (values[customfieldobj.dateoflinkagetoserviceId])
          minDate = values[customfieldobj.dateoflinkagetoserviceId];
        else isDisabled = true;
      }

      if (
        fieldData.dataElement.id ==
        customfieldobj.dateofserviceavailedsocialwelfareId
      ) {
        if (values[customfieldobj.dateofservicesocialwelfareId])
          minDate = values[customfieldobj.dateofservicesocialwelfareId];
        else isDisabled = true;
      }

      if (fieldData.dataElement.id == customfieldobj.dateofbpserviceavailedId) {
        if (values[customfieldobj.dateofbpscreeningId])
          minDate = values[customfieldobj.dateofbpscreeningId];
        else isDisabled = true;
      }
      if (
        fieldData.dataElement.id == customfieldobj.dateofeyeserviceavailedId
      ) {
        if (values[customfieldobj.dateofeyescreeningId])
          minDate = values[customfieldobj.dateofeyescreeningId];
        else isDisabled = true;
      }
      if (
        fieldData.dataElement.id ==
        customfieldobj.dateoforaldentalserviceavailedId
      ) {
        if (values[customfieldobj.dateoforaldentalscreeningId])
          minDate = values[customfieldobj.dateoforaldentalscreeningId];
        else isDisabled = true;
      }

      const checkDate = (firstdate, seconddate) => {
        if (values[firstdate] && values[seconddate]) {
          const inputDate = new Date(values[firstdate]);
          const cutoffDate = new Date(values[seconddate]);

          if (inputDate < cutoffDate) {
            // console.log("Input date is before the cutoff date.");
            values[firstdate] = "";
            minDate = values[seconddate];
          }
        } else {
          if (values[seconddate]) minDate = values[seconddate];
          else isDisabled = true;
        }
      };

      if (
        fieldData.dataElement.id ==
        customfieldobj.dateofdiabetesserviceavailedId
      ) {
        checkDate(
          customfieldobj.dateofdiabetesserviceavailedId,
          customfieldobj.dateofdiabetesscreeningId
        );
      }

      if (
        fieldData.dataElement.id == customfieldobj.dateofchronicserviceavailedId
      ) {
        checkDate(
          customfieldobj.dateofchronicserviceavailedId,
          customfieldobj.dateofchronicpainscreeningId
        );
      }

      if (
        fieldData.dataElement.id == customfieldobj.dateofsleepserviceavailedId
      ) {
        checkDate(
          customfieldobj.dateofsleepserviceavailedId,
          customfieldobj.dateofsleepscreeningId
        );
      }

      if (
        fieldData.dataElement.id ==
        customfieldobj.dateofmentalhealthserviceavailedId
      ) {
        checkDate(
          customfieldobj.dateofmentalhealthserviceavailedId,
          customfieldobj.dateofmentalhealthsscreeningId
        );
      }

      if (
        fieldData.dataElement.id ==
        customfieldobj.dateofrespiratoryserviceavailedId
      ) {
        checkDate(
          customfieldobj.dateofrespiratoryserviceavailedId,
          customfieldobj.dateofrespiratoryscreeningId
        );
      }

      if (
        fieldData.dataElement.id == customfieldobj.dateofstomachserviceavailedId
      ) {
        checkDate(
          customfieldobj.dateofstomachserviceavailedId,
          customfieldobj.dateofstomachscreeningId
        );
      }

      if (
        fieldData.dataElement.id ==
        customfieldobj.dateofotherncdserviceavailedId
      ) {
        checkDate(
          customfieldobj.dateofotherncdserviceavailedId,
          customfieldobj.dateofotherncdscreeningId
        );
      }
      if (fieldData.dataElement.id == customfieldobj.dateserviceavailedaddId) {
        checkDate(
          customfieldobj.dateserviceavailedaddId,
          customfieldobj.addRefDate
        );
      }
      if (fieldData.dataElement.id == customfieldobj.addRefDate) {
        checkDate(customfieldobj.addRefDate, customfieldobj.dateofserviceaddId);
      }
      if (fieldData.dataElement.id == customfieldobj.serviceAvailedDate) {
        checkDate(customfieldobj.serviceAvailedDate, customfieldobj.addRefDate);
      }

      if (fieldData.dataElement.id == customfieldobj.dateofSTItreatmentdateId) {
        checkDate(
          customfieldobj.dateofSTItreatmentdateId,
          customfieldobj.dateofstiscreeningId
        );
      }
      if (
        fieldData.dataElement.id ==
        customfieldobj.dateofsyphilistreatmentcompletionId
      ) {
        checkDate(
          customfieldobj.dateofsyphilistreatmentcompletionId,
          customfieldobj.dateofsyphilistreatmentinitiationId
        );
      }
      if (fieldData.dataElement.id == customfieldobj.TBcompletiondateId) {
        checkDate(
          customfieldobj.TBcompletiondateId,
          customfieldobj.dateoftreatmentinitiationId
        );
      }

      if (
        fieldData.dataElement.id == customfieldobj.cd4testdateId ||
        fieldData.dataElement.id == customfieldobj.vltestdateId
      ) {
        if (values[customfieldobj.artlinkdateId])
          minDate = values[customfieldobj.artlinkdateId];
        else isDisabled = true;
      }

      if (fieldData.dataElement.id == customfieldobj.dateofconfirmationId) {
        if (!values[customfieldobj.hivreferforconfirmationId]) {
          validationResult.hideShow = false;
        }
      }

      if (
        fieldData.dataElement.id == customfieldobj.artlinkdateId ||
        fieldData.dataElement.id == customfieldobj.cd4testdateId ||
        fieldData.dataElement.id == customfieldobj.vltestdateId
      ) {
        if (!values[customfieldobj.artlinkId]) {
          validationResult.hideShow = false;
        }
      }

      if (validationResult.hideShow == false) {
        values[fieldData.dataElement.id] = "";
      }

      const handleDateClear = (de) => {
        // Clear the value of the changed data element
        form.change(de, "");

        // Get child IDs (if any) that should also be cleared
        const childIds = dateDependencies[de] || [];

        // Loop through and clear each dependent field
        childIds.forEach((childId) => {
          form.change(childId, "");
        });
      };

      const handleDateChange = (value, id) => {
        values[id] = value;
        formref.current.change("forceRenderField", Math.random());
        const childIds = dateDependencies[id] || [];

        // Loop through and clear each dependent field
        childIds.forEach((childId) => {
          form.change(childId, "");
          const input = document.querySelector("input[name=" + childId + "]");
          if (input) {
            input.disabled = false;
          }
        });
      };

      setFieldStructure(
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          className={validationResult.hideShow == true ? "" : "hide"}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Field
              name={fieldData.dataElement.id}
              key={`${fieldData.dataElement.id}-${validationResult.hideShow}`}
              placeholder="YYYY-MM-DD"
              validate={
                fieldData.compulsory && validationResult.hideShow === true
                  ? requiredDate
                  : undefined
              }
            >
              {({ input, meta }) => {
                // Determine if there's an error to show
                const showError =
                  (meta.error && meta.touched) ||
                  (meta.error && meta.submitFailed);

                const setDisabled =
                  hivBehavioural &&
                  !AllHIVConditionCheck &&
                  currentStage.name === "CD Screening" &&
                  activeAccordion === "HIV"
                    ? false
                    : !input.value
                    ? false
                    : isDisabled;
                const mDate =
                  hivBehavioural &&
                  currentStage.name === "CD Screening" &&
                  activeAccordion === "HIV"
                    ? "1900-01-01"
                    : minDate;
                return (
                  <DatePicker
                    key={`${fieldData.dataElement.id}-${validationResult.hideShow}`}
                    disabled={setDisabled}
                    label={
                      currentStage.description !== "General Services" &&
                      currentStage.name !==
                        "NCDs Screening, Treatment and Linkages"
                        ? getTranslatedLabels(fieldData.dataElement)
                        : ""
                    }
                    name={fieldData.dataElement.id}
                    required={
                      fieldData.compulsory && validationResult.hideShow === true
                    }
                    InputLabelProps={{ shrink: true }}
                    dateFunsUtils={DateFnsUtils}
                    value={input.value || null}
                    onChange={(value) =>
                      handleDateChange(value, fieldData.dataElement.id)
                    }
                    onBlur={input.onBlur}
                    margin="normal1"
                    variant="dialog"
                    placeholder="YYYY-MM-DD"
                    className={hideField ? "hide" : customClassName}
                    format={showYear === true ? "yyyy" : "yyyy-MM-dd"}
                    error={showError}
                    helperText={showError ? meta.error : ""}
                    minDate={mDate}
                    disableFuture={!fieldData.allowFutureDate}
                  />
                );
              }}
            </Field>
          </div>

          <Tooltip title="Reset Selection">
            <IconButton
              onClick={() => handleDateClear(fieldData.dataElement.id)} //form.change(fieldData.dataElement.id, "")
              aria-label="reset"
              size="small"
              style={{ padding: 3 }}
              disabled={
                hivBehavioural &&
                !AllHIVConditionCheck &&
                currentStage.name === "CD Screening" &&
                activeAccordion === "HIV"
                  ? false
                  : isDisabled
              }
            >
              <ReplayIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Grid>
      );
    }
  }, [validationResult, localStorage.getItem("locale")]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function DateTimeFieldConfig(props) {
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let customClassName;
  let dataElementGroup = props.dataElementGroup;
  let showYear =
    fieldData.dataElement.attributeValues.length > 0 &&
    fieldData.dataElement.attributeValues[0].attribute.name == "showyear"
      ? true
      : false;
  const [fieldStructure, setFieldStructure] = useState(null);
  const [selectedDate, setDate] = useState(new Date());
  const [validationResult, setValidationResult] = useState(null);

  function fetchValidation() {
    const validationResult = Validator(
      fieldData.dataElement.id,
      fieldData,
      values,
      programRules,
      programRulesVariables,
      dataElementGroup
    );
    setValidationResult(validationResult);
  }

  useEffect(() => {
    fetchValidation();
  }, [values]);

  useEffect(() => {
    if (validationResult != null) {
      setFieldStructure(
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          className={validationResult.hideShow == true ? "" : "hide"}
        >
          <DateTimePicker
            disabled={showYear ? true : false}
            label={getTranslatedLabels(fieldData.dataElement)}
            name={fieldData.dataElement.id}
            required={
              fieldData.compulsory && validationResult.hideShow == true
                ? true
                : false
            }
            dateFunsUtils={DateFnsUtils}
            value={
              values[fieldData.dataElement.id] == undefined
                ? selectedDate
                : values[fieldData.dataElement.id]
            }
            margin="normal"
            variant="inline"
            format={showYear == true ? "yyyy" : "yyyy-MM-dd"}
            validate={
              selectedDate.compulsory && validationResult.hideShow == true
                ? hasValue
                : false
            }
            disableFuture={
              fieldData.allowFutureDate ? fieldData.allowFutureDate : false
            }
            className={customClassName}
          />
        </Grid>
      );
    }
  }, [validationResult, localStorage.getItem("locale")]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function AgeFieldConfig(props) {
  const { t } = useTranslation();
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let customClassName = props.customClassName;
  let dataElementGroup = props.dataElementGroup;

  const required = (value) =>
    fieldData.compulsory && validationResult.hideShow == true
      ? value
        ? undefined
        : t("Required")
      : undefined;
  const mustBeNumber = (value) =>
    isNaN(value) && value ? t("Must be a number") : undefined;
  const minValue = (min) => (value) =>
    isNaN(value) || value >= min
      ? undefined
      : t("Should be greater than") + " " + min;
  const composeValidators =
    (...validators) =>
    (value) =>
      validators.reduce(
        (error, validator) => error || validator(value),
        undefined
      );

  const [fieldStructure, setFieldStructure] = useState(null);
  const [validationResult, setValidationResult] = useState(null);

  function fetchValidation() {
    const validationResult = Validator(
      fieldData.dataElement.id,
      fieldData,
      values,
      programRules,
      programRulesVariables,
      dataElementGroup
    );
    setValidationResult(validationResult);
  }

  useEffect(() => {
    fetchValidation();
  }, [values]);

  useEffect(() => {
    if (validationResult != null) {
      setFieldStructure(
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          className={validationResult.hideShow == true ? "" : "hide"}
        >
          <Field
            name={fieldData.dataElement.id}
            label={getTranslatedLabels(fieldData.dataElement)}
            type="number"
            component={InputFieldFF}
            key={fieldData.dataElement.id}
            required={
              fieldData.compulsory && validationResult.hideShow == true
                ? true
                : false
            }
            validate={composeValidators(required, mustBeNumber)}
            className={customClassName}
          />
        </Grid>
      );
    }
  }, [validationResult, localStorage.getItem("locale")]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function PhoneNumberFieldConfig(props) {
  const { t } = useTranslation();
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let customClassName = props.customClassName;
  let dataElementGroup = props.dataElementGroup;

  const numberFormat = (value) =>
    isNaN(value) && value ? `Incorrect format` : undefined;

  const maxLength = (max) => (value) =>
    value
      ? isNaN(value) || value.length > max
        ? t("Should be less than") + " " + max
        : undefined
      : undefined;
  const required = (value) =>
    fieldData.compulsory && validationResult.hideShow == true
      ? value
        ? undefined
        : t("Required")
      : undefined;

  const composeValidators =
    (...validators) =>
    (value) =>
      validators.reduce(
        (error, validator) => error || validator(value),
        undefined
      );

  const [fieldStructure, setFieldStructure] = useState(null);
  const [validationResult, setValidationResult] = useState(null);

  function fetchValidation() {
    const validationResult = Validator(
      fieldData.dataElement.id,
      fieldData,
      values,
      programRules,
      programRulesVariables,
      dataElementGroup
    );
    setValidationResult(validationResult);
  }

  useEffect(() => {
    fetchValidation();
  }, [values]);

  useEffect(() => {
    if (validationResult != null) {
      setFieldStructure(
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          className={validationResult.hideShow == true ? "" : "hide"}
        >
          <Field
            name={fieldData.dataElement.id}
            label={getTranslatedLabels(fieldData.dataElement)}
            type={"number"}
            component={InputFieldFF}
            key={fieldData.dataElement.id}
            required={
              fieldData.compulsory && validationResult.hideShow == true
                ? true
                : false
            }
            validate={composeValidators(required, numberFormat, maxLength(12))}
            className={customClassName}
          />
        </Grid>
      );
    }
  }, [validationResult, localStorage.getItem("locale")]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function EmailFieldConfig(props) {
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let customClassName = props.customClassName;
  let dataElementGroup = props.dataElementGroup;

  const EMAIL_ADDRESS_PATTERN =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

  const invalidEmailMessage = "Please provide a valid email address";

  const email = (value) =>
    isEmpty(value) || (isString(value) && EMAIL_ADDRESS_PATTERN.test(value))
      ? undefined
      : invalidEmailMessage;

  const [fieldStructure, setFieldStructure] = useState(null);
  const [validationResult, setValidationResult] = useState(null);

  function fetchValidation() {
    const validationResult = Validator(
      fieldData.dataElement.id,
      fieldData,
      values,
      programRules,
      programRulesVariables,
      dataElementGroup
    );
    setValidationResult(validationResult);
  }

  useEffect(() => {
    fetchValidation();
  }, [values]);

  useEffect(() => {
    if (validationResult != null) {
      setFieldStructure(
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          className={validationResult.hideShow == true ? "" : "hide"}
        >
          <Field
            name={fieldData.dataElement.id}
            label={getTranslatedLabels(fieldData.dataElement)}
            type={"email"}
            component={InputFieldFF}
            key={fieldData.dataElement.id}
            required={
              fieldData.compulsory && validationResult.hideShow == true
                ? true
                : false
            }
            validate={email}
            className={customClassName}
          />
        </Grid>
      );
    }
  }, [validationResult, localStorage.getItem("locale")]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function DefaultValueField(props) {
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let customClassName = props.customClassName;
  let dataElementGroup = props.dataElementGroup;
  const [UIC, setUIC] = useState(null);

  async function getUIC() {
    if (UIC == null) {
      let getUIC = await apiServices.generateUIC(fieldData.dataElement.id);
      setUIC(getUIC.value);
    }
  }
  useEffect(() => {
    getUIC();
  }, []);

  return (
    <>
      {UIC != null ? (
        <Grid item xs={12} sm={4} md={4}>
          <Field
            name={fieldData.dataElement.id}
            label={getTranslatedLabels(fieldData.dataElement)}
            type={fieldData.dataElement.valueType}
            component={InputFieldFF}
            key={fieldData.dataElement.id}
            defaultValue={UIC}
            disabled={true}
            className={customClassName}
          />
        </Grid>
      ) : (
        <> </>
      )}
    </>
  );
}

function DefaultStageValueField(props) {
  let fieldData = props.fieldData;
  let customClassName = props.customClassName;
  const [randomNumber, setRandomNumber] = useState(null);

  async function getRandomNumber() {
    if (randomNumber == null) {
      let param = {
        length: 8,
      };
      let getRandomNumber = await apiServices.generateRandomNumber(param);
      setRandomNumber(getRandomNumber.random);
    }
  }
  useEffect(() => {
    getRandomNumber();
  }, []);

  return (
    <>
      {randomNumber != null ? (
        <Grid item xs={12} sm={4} md={4}>
          <Field
            name={fieldData.dataElement.id}
            label={getTranslatedLabels(fieldData.dataElement)}
            type={fieldData.dataElement.valueType}
            component={InputFieldFF}
            key={fieldData.dataElement.id}
            defaultValue={randomNumber}
            disbaled={true}
            className={customClassName}
          />
        </Grid>
      ) : (
        <> </>
      )}
    </>
  );
}

function BooleanFieldConfig(props) {
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let customClassName = props.customClassName;
  let dataElementGroup = props.dataElementGroup;
  let currentStage = props.currentStage;
  const switchData = [{ label: "Yes", value: "item1" }];

  const [fieldStructure, setFieldStructure] = useState(null);
  const [validationResult, setValidationResult] = useState(null);

  function fetchValidation() {
    const validationResult = Validator(
      fieldData.dataElement.id,
      fieldData,
      values,
      programRules,
      programRulesVariables,
      dataElementGroup
    );
    setValidationResult(validationResult);
  }

  useEffect(() => {
    fetchValidation();
  }, [values]);

  useEffect(() => {
    if (validationResult != null) {
      setFieldStructure(
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          className={validationResult.hideShow == true ? "" : "hide"}
        >
          <Switches
            label={
              currentStage.description != "General Services" &&
              currentStage.name != "NCDs Screening, Treatment and Linkages"
                ? getTranslatedLabels(fieldData.dataElement)
                : ""
            }
            name={fieldData.dataElement.id}
            disableRipple
            required={
              fieldData.compulsory && validationResult.hideShow == true
                ? true
                : false
            }
            data={switchData}
            className={customClassName}
          />
        </Grid>
      );
    }
  }, [validationResult, localStorage.getItem("locale")]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function TimeFieldConfig(props) {
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let customClassName = props.customClassName;
  let dataElementGroup = props.dataElementGroup;
  let showYear =
    fieldData.dataElement.attributeValues.length > 0 &&
    fieldData.dataElement.attributeValues[0].attribute.name == "showyear"
      ? true
      : false;
  const [fieldStructure, setFieldStructure] = useState(null);
  const [selectedDate, setDate] = useState(new Date());
  const [validationResult, setValidationResult] = useState(null);

  function fetchValidation() {
    const validationResult = Validator(
      fieldData.dataElement.id,
      fieldData,
      values,
      programRules,
      programRulesVariables,
      dataElementGroup
    );
    setValidationResult(validationResult);
  }

  useEffect(() => {
    fetchValidation();
  }, [values]);

  useEffect(() => {
    if (validationResult != null) {
      setFieldStructure(
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          className={validationResult.hideShow == true ? "" : "hide"}
        >
          <TimePicker
            label={fieldData.dataElement.displayFormName}
            name={fieldData.dataElement.id}
            required={
              fieldData.compulsory && validationResult.hideShow == true
                ? true
                : false
            }
            dateFunsUtils={DateFnsUtils}
            margin="normal"
            variant="inline"
            format="HH:MM"
            className={customClassName}
          />
        </Grid>
      );
    }
  }, [validationResult, localStorage.getItem("locale")]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function IntegerConfig(props) {
  const { t } = useTranslation();
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let customClassName = props.customClassName;
  let dataElementGroup = props.dataElementGroup;
  let currentStage = props.currentStage;
  let Configuration = props.configuration;
  let isDisabled = false;
  let customfieldobj = props.customfieldobj;
  let hivarray = props.hivarray;
  const hivConditions = props.hivConditions;
  let maxLen = 10;
  let customProps = {};

  const maxLength = (max) => (value) =>
    value && value.length > max
      ? `The maximum allowed length is ${max} digits`
      : undefined;

  const required = (value) =>
    fieldData.compulsory && validationResult.hideShow == true
      ? value
        ? undefined
        : t("Required")
      : undefined;
  const mustBeNumber = (value) =>
    isNaN(value) && value ? t("Must be a number") : undefined;
  const minValue = (min) => (value) =>
    isNaN(value) || value >= min
      ? undefined
      : t("Should be greater than") + " " + min;

  const maxValue = (max) => (value) =>
    isNaN(value) || value <= max
      ? undefined
      : t("Should be less than") + " " + max;

  const composeValidators =
    (...validators) =>
    (value) =>
      validators.reduce(
        (error, validator) => error || validator(value),
        undefined
      );

  const [fieldStructure, setFieldStructure] = useState(null);
  const [validationResult, setValidationResult] = useState(null);

  function fetchValidation() {
    const validationResult = Validator(
      fieldData.dataElement.id,
      fieldData,
      values,
      programRules,
      programRulesVariables,
      dataElementGroup
    );
    setValidationResult(validationResult);
  }

  useEffect(() => {
    fetchValidation();
  }, [values]);

  function calculateBMI(weightKg, heightCm) {
    // Convert height from centimeters to meters
    const heightM = heightCm / 100;

    // Calculate BMI
    let bmi = weightKg / (heightM * heightM);
    bmi = bmi.toFixed(2);
    return bmi;
  }

  useEffect(() => {
    if (validationResult != null) {
      const matchingRule = Configuration.validationRule.find((rule) => {
        const isChild = rule.child === fieldData.dataElement.id;
        const actualValue = values[rule.id];
        const expectedValue = rule.value;
        const valueMismatch = actualValue !== expectedValue;

        return isChild && valueMismatch;
      });

      if (matchingRule) {
        isDisabled = matchingRule.isDisabled;
      }

      const mandatoryRule = Configuration?.mandatoryRule.find((rule) => {
        const isChild = rule.child === fieldData.dataElement.id;
        const actualValue = values[rule.id];
        const expectedValue = rule.value;
        const valueMismatch = actualValue === expectedValue;

        return isChild && valueMismatch;
      });

      if (mandatoryRule) {
        fieldData.mandatory = mandatoryRule.isMandatory;
      }

      const isFieldHidden = (fieldData) => {
        // Replace this with your actual logic to determine if the field should be hidden
        return fieldData.hide || validationResult?.hideShow === false;
      };

      if (
        hivarray.find(
          (field) => field.id === fieldData.dataElement.id && field.status
        )
      ) {
        isDisabled = true;
      }

      if (
        fieldData.dataElement.id == customfieldobj.bpSystolicId ||
        fieldData.dataElement.id == customfieldobj.bpDiastolicId ||
        fieldData.dataElement.id == customfieldobj.pulseId ||
        fieldData.dataElement.id == customfieldobj.heightId ||
        fieldData.dataElement.id == customfieldobj.weightId
      ) {
        maxLen = 3;
      }

      if (
        fieldData.dataElement.id == customfieldobj.bmiID &&
        values[customfieldobj.weightId] &&
        values[customfieldobj.heightId]
      ) {
        values[customfieldobj.bmiID] = calculateBMI(
          values[customfieldobj.weightId],
          values[customfieldobj.heightId]
        );
        customProps = {
          ...customProps,
          key: Math.random() * 9999,
        };
      }

      if (fieldData.dataElement.id == customfieldobj.bmiID) {
        isDisabled = true;
      }

      if (fieldData.dataElement.id == customfieldobj.DiabetesIndaysId) {
        if (values[customfieldobj.DiabetesPEDId] != "Yes") {
          values[customfieldobj.DiabetesIndaysId] = "";
        }
      }

      if (validationResult.hideShow == false) {
        values[fieldData.dataElement.id] = "";
      }

      if (
        fieldData.dataElement.id == customfieldobj.onartnumberId ||
        fieldData.dataElement.id == customfieldobj.cd4countId ||
        fieldData.dataElement.id == customfieldobj.vlcountId
      ) {
        if (!values[customfieldobj.artlinkId]) {
          validationResult.hideShow = false;
        }
      }

      setFieldStructure(
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          className={validationResult.hideShow == true ? "" : "hide"}
        >
          <Field
            name={fieldData.dataElement.id}
            label={
              currentStage.description != "General Services" &&
              currentStage.name != "NCDs Screening, Treatment and Linkages"
                ? getTranslatedLabels(fieldData.dataElement)
                : ""
            }
            type={"number"}
            component={InputFieldFF}
            key={fieldData.dataElement.id}
            required={
              fieldData.compulsory && validationResult.hideShow == true
                ? true
                : false
            }
            validate={
              !isFieldHidden(fieldData)
                ? composeValidators(required, mustBeNumber, maxLength(maxLen))
                : undefined
            }
            value=""
            disabled={isDisabled}
            className={customClassName}
            {...customProps}
          />
        </Grid>
      );
    }
  }, [validationResult, localStorage.getItem("locale")]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function TextAreaConfig(props) {
  const { t } = useTranslation();
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let customClassName = props.customClassName;
  let dataElementGroup = props.dataElementGroup;

  const [fieldStructure, setFieldStructure] = useState(null);
  const [validationResult, setValidationResult] = useState(null);

  const required = (value) =>
    fieldData.compulsory && validationResult.hideShow == true
      ? value
        ? undefined
        : t("Required")
      : undefined;
  const scriptCheck = (value) =>
    value
      ? value.match(/<[^>]*>/g) != null
        ? t('Incorrect expression "< or >" added as input')
        : undefined
      : undefined;
  const composeValidators =
    (...validators) =>
    (value) =>
      validators.reduce(
        (error, validator) => error || validator(value),
        undefined
      );

  function fetchValidation() {
    const validationResult = Validator(
      fieldData.dataElement.id,
      fieldData,
      values,
      programRules,
      programRulesVariables,
      dataElementGroup
    );
    setValidationResult(validationResult);
  }

  useEffect(() => {
    fetchValidation();
  }, [values]);

  useEffect(() => {
    if (validationResult != null) {
      setFieldStructure(
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          className={validationResult.hideShow == true ? "" : "hide"}
        >
          <Field
            name={fieldData.dataElement.id}
            label={getTranslatedLabels(fieldData.dataElement)}
            type={"text"}
            component={InputFieldFF}
            key={fieldData.dataElement.id}
            required={
              fieldData.compulsory && validationResult.hideShow == true
                ? true
                : false
            }
            validate={composeValidators(required, scriptCheck)}
            autoGrow
            className={customClassName}
          />
        </Grid>
      );
    }
  }, [validationResult, localStorage.getItem("locale")]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function UserNameConfig(props) {
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let customClassName = props.customClassName;
  let dataElementGroup = props.dataElementGroup;
  let orgunitid = props.programorgid;
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [fieldStructure, setFieldStructure] = useState(null);
  const [validationResult, setValidationResult] = useState(null);

  function fetchValidation() {
    const validationResult = Validator(
      fieldData.dataElement.id,
      fieldData,
      values,
      programRules,
      programRulesVariables,
      dataElementGroup
    );
    setValidationResult(validationResult);
  }
  function fetchCustomUsersList() {
    setGlobalSpinner(true);
    let options = [];
    apiServices
      .getAPI(
        "users?paging=true&page=1&pageSize=10&query=&fields=firstName,surname,userCredentials[username],id&ou=" +
          orgunitid
      )
      .then((response) => {
        setGlobalSpinner(false);

        response.data.users.map((user) => {
          let obj = {
            id: user.id,
            label: user.firstName + " " + user.surname,
            value: user.id,
          };
          options.push(obj);
          setDropdownOptions(options);
          setGlobalSpinner(false);
        });
      })
      .catch((err) => {
        setGlobalSpinner(false);
      });
  }
  useEffect(() => {
    fetchCustomUsersList();
  }, []);
  useEffect(() => {
    fetchValidation();
  }, [values]);

  useEffect(() => {
    if (validationResult != null && dropdownOptions.length > 0) {
      setFieldStructure(
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          className={validationResult.hideShow == true ? "" : "hide"}
        >
          <Field
            id={fieldData.dataElement.id}
            name={fieldData.dataElement.id}
            label={getTranslatedLabels(fieldData.dataElement)}
            component={SingleSelectFieldFF}
            key={fieldData.dataElement.id}
            validate={
              fieldData.compulsory && validationResult.hideShow == true
                ? hasValue
                : false
            }
            required={
              fieldData.compulsory && validationResult.hideShow == true
                ? true
                : false
            }
            options={dropdownOptions}
            disabled={
              fieldData.dataElement.attributeValues &&
              fieldData.dataElement.attributeValues.length > 0
                ? fieldData.dataElement.attributeValues[0].attribute.name ==
                  "isDisabled"
                  ? true
                  : false
                : false
            }
            className={customClassName}
          />
        </Grid>
      );
    }
  }, [validationResult, dropdownOptions, localStorage.getItem("locale")]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function URLConfig(props) {
  const { t } = useTranslation();
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let customClassName = props.customClassName;
  let dataElementGroup = props.dataElementGroup;
  let regexp =
    /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
  const required = (value) =>
    fieldData.compulsory && validationResult.hideShow == true
      ? value
        ? undefined
        : t("Required")
      : undefined;

  const URLCheck = (value) =>
    regexp.test(value) ? undefined : t("Incorrect URL format");

  const composeValidators =
    (...validators) =>
    (value) =>
      validators.reduce(
        (error, validator) => error || validator(value),
        undefined
      );

  const [fieldStructure, setFieldStructure] = useState(null);
  const [validationResult, setValidationResult] = useState(null);

  function fetchValidation() {
    const validationResult = Validator(
      fieldData.dataElement.id,
      fieldData,
      values,
      programRules,
      programRulesVariables,
      dataElementGroup
    );
    setValidationResult(validationResult);
  }

  useEffect(() => {
    fetchValidation();
  }, [values]);

  useEffect(() => {
    if (validationResult != null) {
      setFieldStructure(
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          className={validationResult.hideShow == true ? "" : "hide"}
        >
          {getTranslatedLabels(fieldData.dataElement)} :
          <a target="_blank" href={values[fieldData.dataElement.id]}>
            URL
          </a>
        </Grid>
      );
    }
  }, [validationResult, localStorage.getItem("locale")]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function HandleOUOptions(props) {
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let customClassName = props.customClassName;
  let OUMappingList = OUMapping(values);
  let parentValue =
    OUMappingList[fieldData.dataElement.id] != undefined
      ? values[OUMappingList[fieldData.dataElement.id].parent]
      : null;
  let programData = props.programData;
  let options = props.options;
  let defaultOption = props.defaultOption;
  let customfieldobj = props.customfieldobj;
  let hivarray = props.hivarray;
  const hivConditions = props.hivConditions;
  let hideField = false;
  let isDisabled = false;
  let AllHIVConditionCheck = props.AllHIVConditionCheck;
  let rules = {
    programRule: props.programRules,
    programRuleVariable: props.programRulesVariables,
  };
  let OUJSON = props.OUJSON.organisationUnits;

  if (
    fieldData.dataElement.displayName == "Referral facility" ||
    fieldData.dataElement.displayName == "Sample transferred to facility "
  ) {
    OUJSON = OUJSON.filter((obj) => obj.comment == "Facility");
  }

  const option = { id: "option1", label: "Option1", value: "option1" };

  const [fieldStructure, setFieldStructure] = useState(null);
  const [validationResult, setValidationResult] = useState(null);
  const [location, setLocation] = useState([]);

  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  useEffect(() => {
    if (options != "") {
      let locationList = [];
      const filterOnId = OUJSON.filter((obj) => obj.id == options);
      if (filterOnId.length > 0) {
        const childrenOptions = filterOnId[0].children;
        childrenOptions.map((childOptions) => {
          const filterChildDetails = OUJSON.filter(
            (obj) => obj.id == childOptions.id
          );
          if (filterChildDetails.length > 0) {
            let obj = {
              id: filterChildDetails[0].id,
              label: filterChildDetails[0].name,
              value: filterChildDetails[0].id,
            };
            locationList.push(obj);
            setLocation(locationList);
          }
        });
      }

      if (
        fieldData.dataElement.displayName == "Referral facility" ||
        fieldData.dataElement.displayName == "Sample transferred to facility "
      ) {
        OUJSON.map((facility) => {
          let obj = {
            id: facility["id"],
            label: facility["name"],
            value: facility["id"],
          };
          locationList.push(obj);
          locationList = _.orderBy(locationList, ["label"], ["asc"]);
          setLocation(locationList);
        });
      }
    } else {
      const OUList = programData.organisationUnits;
      let autocompleteData = [];

      if (OUMappingList[fieldData.dataElement.id] != undefined) {
        if (OUMappingList[fieldData.dataElement.id].type) {
          let OUOptions = OUJSON.filter(
            (obj) => obj.level == OUMappingList[fieldData.dataElement.id].level
          );
          if (OUOptions.length > 0) {
            OUOptions.map((items) => {
              let obj = {
                id: items.id,
                label: items.name,
                value: items.id,
              };
              autocompleteData.push(obj);
            });
            setLocation(autocompleteData);
          }
        }
      } else {
        let OUOptions = OUJSON;
        OUOptions = OUJSON.filter((obj) => obj.comment == "Facility");
        if (OUOptions.length > 0) {
          OUOptions.map((items) => {
            let obj = {
              id: items.id,
              label: items.name,
              value: items.id,
            };
            autocompleteData.push(obj);
          });
          setLocation(autocompleteData);
        }
      }

      if (
        fieldData.dataElement.displayName == "Referral facility" ||
        fieldData.dataElement.displayName == "Sample transferred to facility "
      ) {
        OUJSON.map((facility) => {
          let obj = {
            id: facility["id"],
            label: facility["name"],
            value: facility["id"],
          };
          autocompleteData.push(obj);
          autocompleteData = _.orderBy(autocompleteData, ["label"], ["asc"]);
          setLocation(autocompleteData);
        });
      }

      if (
        fieldData.dataElement.id == "fVBIn27ZUW9" &&
        values[customfieldobj.artlinkId] != "Yes"
      ) {
        hideField = true;
      }
    }
  }, [
    values[fieldData.dataElement.id],
    parentValue,
    options,
    localStorage.getItem("locale"),
  ]); //defaultOption, options

  useEffect(() => {
    if (location != null) {
      const matchedField = hivarray.find(
        (field) => field.id === fieldData.dataElement.id && field.status
      );

      if (matchedField) {
        isDisabled = checkDisabledField({
          hivarray,
          fieldData,
          hivConditions,
          AllHIVConditionCheck,
        });
      }

      if (hideField == false) {
        values[fieldData.dataElement.id] = "";
      }

      if (
        fieldData.dataElement.id == customfieldobj.artStateId ||
        fieldData.dataElement.id == customfieldobj.artDistrictId ||
        fieldData.dataElement.id == customfieldobj.nameofartId
      ) {
        if (
          values[customfieldobj.resultofconfirmatorytestId] != "Positive" ||
          !values[customfieldobj.artlinkId]
        ) {
          hideField = false;
        }
      }

      if (values[fieldData.dataElement.id]) {
        if (!_.isEmpty(defaultOption)) {
          setFieldStructure(
            <OUFieldConfig
              data={fieldData}
              values={values}
              rules={rules}
              options={location}
              defaultOption={defaultOption}
              customfieldobj={customfieldobj}
              hideField={hideField}
              programData={programData}
              OUMapping={OUMappingList}
              customClassName={customClassName}
              isDisabled={isDisabled}
            />
          );
        }
      } else {
        setFieldStructure(
          <OUFieldConfig
            data={fieldData}
            values={values}
            rules={rules}
            options={location}
            defaultOption={defaultOption}
            customfieldobj={customfieldobj}
            hideField={hideField}
            programData={programData}
            OUMapping={OUMappingList}
            customClassName={customClassName}
            isDisabled={isDisabled}
          />
        );
      }
    }
  }, [location, values, isDisabled, localStorage.getItem("locale")]);
  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function ReferalConfig(props) {
  let fieldData = props.fieldData;

  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let customClassName = props.customClassName;
  let dataElementGroup = props.dataElementGroup;
  let programData = props.programData;
  let customfieldobj = props.customfieldobj;
  let programBoDetails = props.programBoDetails;
  let referralWorkFlow =
    programBoDetails && programBoDetails.isReferralWorkflow ? true : false;
  let symptomsFID = props.symptomsFID ? props.symptomsFID : "";
  let Configuration = props.Configuration;
  const stagesList = programData.programStages;
  const { t } = useTranslation();
  const [referralDefaultValue, setReferralDefaultValue] = useState(null);
  let checkboxData = [];
  let isCheckboxReadOnly = false,
    readOnlyCheckboxArr = [];

  let defaultval = "";

  let testingStage = customfieldobj.tbTestingStageId; //stagesList.filter(obj => obj.description == "Testing Form")
  let tbInfectionTestingStage = customfieldobj.tbInfectionTestingStageId; //stagesList.filter(obj => obj.description == "TB Treatment Initiation") //ltbi
  let tptInitiation = customfieldobj.tptIntiationStageId; //stagesList.filter(obj => obj.description == "TPT  Initiation Form") //TPT ltbi
  if (referralWorkFlow) {
    if (
      values[customfieldobj.eligibleforTPTId] == "Yes" &&
      values[customfieldobj.testingforTBinfectionID] == "No"
    ) {
      //&& values[customfieldobj.testingforTBinfectionID] == 'No'
      defaultval = tptInitiation; //tptInitiation[0].id
    } else if (
      values[customfieldobj.mWRDresultId] == "Negative" &&
      values[customfieldobj.mWRDreportavailableID] == "Yes"
    ) {
      defaultval = tbInfectionTestingStage;
    } else if (
      values[customfieldobj.mWRDresultId] == "Positive" &&
      values[customfieldobj.mWRDreportavailableID] == "Yes"
    ) {
      defaultval = customfieldobj.tbTretmentInitiationStageId;
    } else if (
      (values[customfieldobj.CXRreportavailableID] == "Yes" &&
        values[customfieldobj.CXRresultId] == "Suggestive of TB") ||
      (values[customfieldobj.CRPreportavailableID] == "Yes" &&
        values[customfieldobj.CRPresultId] == "Positive") ||
      (symptomsFID &&
        values[symptomsFID] &&
        _.isArray(values[symptomsFID]) &&
        values[symptomsFID].length > 0 &&
        !values[symptomsFID].includes(customfieldobj.noneOptionID))
    ) {
      defaultval = testingStage; //tbTestingStage[0].id
    } else {
      if (
        values[customfieldobj.CXRresultId] == "Not suggestive of TB" ||
        values[customfieldobj.mWRDreportavailableID] == "No" ||
        (symptomsFID &&
          values[symptomsFID] &&
          _.isArray(values[symptomsFID]) &&
          values[symptomsFID].length > 0 &&
          values[symptomsFID].includes(customfieldobj.noneOptionID))
      ) {
        defaultval = tbInfectionTestingStage; //testingStage
      } else {
        defaultval = tbInfectionTestingStage;
      }
    }

    if (
      values &&
      customfieldobj.selectReferralServiceId == fieldData.dataElement.id
    ) {
      if (!values[customfieldobj.selectReferralServiceId]) {
        values[customfieldobj.selectReferralServiceId] = ""; //[];
      }
      if (defaultval) {
        values[customfieldobj.selectReferralServiceId] = defaultval; //.push(defaultval);
      }
    }
    if (
      values[customfieldobj.selectReferralServiceId] &&
      _.isArray(values[customfieldobj.selectReferralServiceId])
    ) {
      values[customfieldobj.selectReferralServiceId] = tbInfectionTestingStage
        ? tbInfectionTestingStage
        : values[customfieldobj.selectReferralServiceId][0];
    }

    if (
      Configuration &&
      Configuration.ltbiLinkVariables &&
      values[customfieldobj.clientTypeID] ==
        Configuration.ltbiLinkVariables.index
    ) {
      values[customfieldobj.selectReferralServiceId] =
        customfieldobj.tbTretmentInitiationStageId;
    }
  } else {
    if (
      values[customfieldobj.selectReferralServiceId] &&
      _.isArray(values[customfieldobj.selectReferralServiceId])
    ) {
      values[customfieldobj.selectReferralServiceId] = tbInfectionTestingStage
        ? tbInfectionTestingStage
        : values[customfieldobj.selectReferralServiceId][0];
    }
  }

  if (!values[customfieldobj.selectReferralServiceId]) {
    values[customfieldobj.selectReferralServiceId] = tbInfectionTestingStage
      ? tbInfectionTestingStage
      : testingStage; //testingStage
  }

  const [fieldStructure, setFieldStructure] = useState(null);
  const [validationResult, setValidationResult] = useState(null);

  function fetchValidation() {
    const validationResult = Validator(
      fieldData.dataElement.id,
      fieldData,
      values,
      programRules,
      programRulesVariables,
      dataElementGroup
    );
    setValidationResult(validationResult);
  }

  function getFieldDetails(stage, parentAttribute, parentReadOnlyCheckboxArr) {
    let isDisabled = false;
    let customProps = {};
    if (referralWorkFlow) {
      customProps = { ...customProps };
      customProps.disabled = true; //false
      //customProps.initialValue = parentReadOnlyCheckboxArr
      if (defaultval) {
        customProps.initialValue = [defaultval];
      }
    }

    return (
      <>
        <Field
          type="radio"
          component={RadioFieldFF}
          name={parentAttribute.dataElement.id}
          label={stage.label}
          value={stage.value}
          required={true}
          disabled={isDisabled}
          {...customProps}
          className={customClassName}
        />
        <OnChange name={parentAttribute.dataElement.id}>
          {(value, previous) => {
            if (!defaultval) {
              values[customfieldobj.selectReferralServiceId] = value;
            }
          }}
        </OnChange>
      </>
    );
  }

  useEffect(() => {
    fetchValidation();
  }, [values]);

  useEffect(() => {
    if (validationResult != null) {
      stagesList.map((stage) => {
        // readynoly checkbox logic for savemynmar
        if (stage.attributeValues.length > 0) {
          stage.attributeValues.map((val) => {
            if (
              val.attribute.displayName == "showStageNameInReferralService" &&
              val.value == "true"
            ) {
              if (stage.id == defaultval) {
                readOnlyCheckboxArr.push(stage.id);
              }
              isCheckboxReadOnly = true;
              checkboxData.push({
                label: stage.displayName
                  ? t(stage.displayName)
                  : t(stage.description),
                value: stage.id,
              });
            }
          });
        }
      });

      setFieldStructure(
        <Grid
          item
          xs={12}
          sm={4}
          className={
            validationResult.hideShow == true
              ? "customLoc " + customClassName
              : "hide"
          }
        >
          <FieldGroupFF
            label={getTranslatedLabels(fieldData.dataElement)}
            required={
              fieldData.compulsory && validationResult.hideShow == true
                ? true
                : false
            }
            name={fieldData.dataElement.id}
            className={customClassName}
          >
            {checkboxData.map((stage) => {
              return getFieldDetails(stage, fieldData, readOnlyCheckboxArr);
            })}
          </FieldGroupFF>
        </Grid>
      );
    }
  }, [validationResult, localStorage.getItem("locale")]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function MultiSelectConfig1(props) {
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let customClassName = props.customClassName;
  let DataElementGroup = props.DataElementGroup;
  let customfieldobj = props.customfieldobj;
  let programObj = props.programObj;
  let dataElementGroup = props.dataElementGroup;
  let Configuration = props.configuration;
  let stage = props.stages;
  let isDisabled = false;
  let noneFieldId = customfieldobj.noneOptionID; //"ATGexAEZ8xm"
  let customProps = {};
  const [showAll, setShowAll] = useState(false);
  const visibleCount = 3;
  const toggleShowAll = () => setShowAll((prev) => !prev);
  const [fieldStructure, setFieldStructure] = useState(null);
  const [validationResult, setValidationResult] = useState(null);

  function fetchValidation() {
    const validationResult = Validator(
      fieldData.dataElement.id,
      fieldData,
      values,
      programRules,
      programRulesVariables,
      dataElementGroup
    );
    setValidationResult(validationResult);
  }

  function getFieldDetails(fieldId, parentAttribute, formValues) {
    const getFieldsAttributes = stage.filter(
      (obj) => obj.dataElement.id == fieldId
    );

    if (getFieldsAttributes.length > 0) {
      const fieldData1 = getFieldsAttributes[0];
      const findField = fieldData1.dataElement.id;
      let autoChecked = false;
      try {
        if (findField != undefined && formValues[findField]) {
          if (
            values[DataElementGroup.id] &&
            _.isArray(values[DataElementGroup.id]) &&
            _.last(values[DataElementGroup.id]) &&
            _.last(values[DataElementGroup.id]) != noneFieldId
          ) {
            if (values[findField] == true && findField != noneFieldId) {
              if (
                values[DataElementGroup.id] &&
                values[DataElementGroup.id].includes(noneFieldId)
              ) {
                values[DataElementGroup.id] = values[
                  DataElementGroup.id
                ].filter((item) => item !== noneFieldId);
              }
              delete values[noneFieldId];
            }
          } else if (
            values[DataElementGroup.id] &&
            _.isArray(values[DataElementGroup.id]) &&
            _.last(values[DataElementGroup.id]) &&
            _.last(values[DataElementGroup.id]) == noneFieldId
          ) {
            values[DataElementGroup.id].map((ele) => {
              if (ele != noneFieldId) delete values[ele];
            });
            values[DataElementGroup.id] = [noneFieldId];
          }
        }
      } catch (e) {}

      const matchingRule = Configuration.validationRule.find((rule) => {
        const isChild = rule.child === parentAttribute.id;
        const actualValue = values[rule.id];
        const expectedValue = rule.value;
        const valueMismatch = actualValue !== expectedValue;

        return isChild && valueMismatch;
      });

      if (matchingRule) {
        isDisabled = matchingRule.isDisabled;
      }

      const mandatoryRule = Configuration.mandatoryRule.find((rule) => {
        const isChild = rule.child === parentAttribute.id;
        const actualValue = values[rule.id];
        const expectedValue = rule.value;
        const valueMismatch = actualValue === expectedValue;

        return isChild && valueMismatch;
      });

      if (mandatoryRule) {
        isDisabled = mandatoryRule.isDisabled;
      }

      return autoChecked == true ? (
        <Field
          component={CheckboxFieldFF}
          name={DataElementGroup.id}
          disabled={isDisabled}
          label={getTranslatedLabels(fieldData1.dataElement)}
          value={fieldData1.dataElement.id}
          initialValue={formValues[DataElementGroup.id]}
          className={customClassName}
        />
      ) : (
        <Field
          type="checkbox"
          component={CheckboxFieldFF}
          name={DataElementGroup.id}
          disabled={isDisabled}
          label={getTranslatedLabels(fieldData1.dataElement)}
          value={fieldData1.dataElement.id}
          initialValue={formValues[DataElementGroup.id]}
          className={customClassName}
        />
      );
    }
  }

  useEffect(() => {
    fetchValidation();
  }, [values]);

  useEffect(() => {
    if (validationResult != null) {
      let fieldLabel = getTranslatedLabels(DataElementGroup);
      try {
        if (fieldLabel.includes("_")) {
          let l = fieldLabel.split("_");
          fieldLabel = l[1];
        }
      } catch (e) {}

      const atLeastOneSelected = (value, allValues) => {
        const groupElements = DataElementGroup.dataElements.map((el) => el.id);
        const isAnyChecked = groupElements.some((id) => allValues[id]);
        return isAnyChecked ? undefined : "Please select at least one option";
      };

      setFieldStructure(
        <Grid
          item
          xs={12}
          sm={4}
          className={
            validationResult.hideShow == true
              ? "customLoc " + customClassName
              : "hide"
          }
        >
          <FieldGroupFF
            label={fieldLabel}
            name={DataElementGroup.id}
            className={customClassName}
          >
            {(showAll
              ? DataElementGroup.dataElements
              : DataElementGroup.dataElements.slice(0, visibleCount)
            ).map((field) =>
              getFieldDetails(field.id, DataElementGroup, values)
            )}

            {DataElementGroup.dataElements.length > visibleCount && (
              <div style={{ marginTop: "0.5rem" }}>
                <button
                  type="button"
                  onClick={toggleShowAll}
                  style={{
                    color: "#0073e6",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  {showAll ? "Show Less ▲" : "Show More ▼"}
                </button>
              </div>
            )}

            {/* ✅ One-time error message */}
            <Field
              name={DataElementGroup.id}
              validate={(value, allValues) => {
                const groupElements = DataElementGroup.dataElements.map(
                  (el) => el.id
                );
                const isAnyChecked = groupElements.some((id) => allValues[id]);
                return isAnyChecked
                  ? undefined
                  : "Please select at least one option";
              }}
              subscription={{ touched: true, error: true }}
            >
              {({ meta }) =>
                meta.touched && meta.error ? (
                  <div
                    style={{
                      color: "red",
                      fontSize: "0.875rem",
                      marginTop: "4px",
                    }}
                  >
                    {meta.error}
                  </div>
                ) : null
              }
            </Field>
          </FieldGroupFF>
        </Grid>
      );
    }
  }, [validationResult, showAll, localStorage.getItem("locale")]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function MultiSelectConfig(props) {
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let customClassName = props.customClassName;
  let DataElementGroup = props.DataElementGroup;
  let customfieldobj = props.customfieldobj;
  let programObj = props.programObj;
  let dataElementGroup = props.dataElementGroup;
  let stage = props.stages;
  let noneFieldId = customfieldobj.noneOptionID; //"ATGexAEZ8xm"
  let formref = props.formref;
  let customProps = {};
  const form = useForm();
  const [fieldStructure, setFieldStructure] = useState(null);
  const [validationResult, setValidationResult] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [forceRender, setForceRender] = useState(false);

  function fetchValidation() {
    const validationResult = Validator(
      fieldData.dataElement.id,
      fieldData,
      values,
      programRules,
      programRulesVariables,
      dataElementGroup
    );
    setValidationResult(validationResult);
  }

  function getFieldDetails(fieldId, formValues) {
    const getFieldsAttributes = stage.filter(
      (obj) => obj.dataElement.id == fieldId
    );

    if (getFieldsAttributes.length > 0) {
      const fieldData1 = getFieldsAttributes[0];
      const findField = fieldData1.dataElement.id;
      let isFieldDisbaled = false;
      let autoChecked = false;
      try {
        if (findField != undefined && formValues[findField]) {
          if (
            values[DataElementGroup.id] &&
            _.isArray(values[DataElementGroup.id]) &&
            _.last(values[DataElementGroup.id]) &&
            _.last(values[DataElementGroup.id]) != noneFieldId
          ) {
            if (values[findField] == true && findField != noneFieldId) {
              if (
                values[DataElementGroup.id] &&
                values[DataElementGroup.id].includes(noneFieldId)
              ) {
                values[DataElementGroup.id] = values[
                  DataElementGroup.id
                ].filter((item) => item !== noneFieldId);
              }
              delete values[noneFieldId];
            }
          } else if (
            values[DataElementGroup.id] &&
            _.isArray(values[DataElementGroup.id]) &&
            _.last(values[DataElementGroup.id]) &&
            _.last(values[DataElementGroup.id]) == noneFieldId
          ) {
            values[DataElementGroup.id].map((ele) => {
              if (ele != noneFieldId) delete values[ele];
            });
            values[DataElementGroup.id] = [noneFieldId];
          }
        }
      } catch (e) {}

      return autoChecked == true ? (
        <Field
          component={CheckboxFieldFF}
          name={DataElementGroup.id}
          disabled={isFieldDisbaled}
          label={getTranslatedLabels(fieldData1.dataElement)}
          value={fieldData1.dataElement.id}
          initialValue={formValues[DataElementGroup.id]}
          className={customClassName}
        />
      ) : (
        <Field
          type="checkbox"
          component={CheckboxFieldFF}
          name={DataElementGroup.id}
          // disabled={isFieldDisbaled}
          label={getTranslatedLabels(fieldData1.dataElement)}
          value={fieldData1.dataElement.id}
          initialValue={formValues[DataElementGroup.id]}
          className={customClassName}
        />
      );
    }
  }

  const loadOptions = (inputValue, callback) => {
    const filteredOptions = DataElementGroup.dataElements
      .filter((de) =>
        de.displayName.toLowerCase().includes(inputValue.toLowerCase())
      )
      .map((de) => ({
        label: de.displayName.includes("_")
          ? de.displayName.split("_")[0]
          : de.displayName,
        value: de.id,
      }));
    callback(filteredOptions);
  };

  useEffect(() => {
    fetchValidation();
  }, [values]);

  useEffect(() => {
    setSelectedOptions([]);
    if (
      values[DataElementGroup.id] &&
      Array.isArray(values[DataElementGroup.id])
    ) {
      const preselected = DataElementGroup.dataElements
        .filter(
          (de) =>
            values[DataElementGroup.id].includes(de.id) ||
            values[de.id] === true
        )
        .map((de) => ({ label: de.displayName, value: de.id }));
      if (preselected.length > 0) {
        setSelectedOptions(preselected);
      }
    }
  }, [values[DataElementGroup.id], DataElementGroup]);

  useEffect(() => {
    if (validationResult != null) {
      let fieldLabel = getTranslatedLabels(DataElementGroup);
      try {
        if (fieldLabel.includes("_")) {
          let l = fieldLabel.split("_");
          fieldLabel = l[1];
        }
      } catch (e) {}
      const sortedDataElements = [...DataElementGroup.dataElements].sort(
        (a, b) => a.displayName.localeCompare(b.displayName)
      );

      // Transform the options for display and log the result
      const displayOptions =
        selectedOptions.length > 0
          ? selectedOptions.map((option) => {
              const transformedOption = {
                label: option.label.includes("_")
                  ? option.label.split("_")[0]
                  : option.label,
                value: option.value,
              };
              return transformedOption;
            })
          : null;

      if (validationResult.hideShow == false) {
        values[DataElementGroup.id] = "";
      }

      // signs and symtoms dropdown
      setFieldStructure(
        <Grid
          item
          xs={12}
          sm={12}
          lg={12}
          md={12}
          className={
            validationResult.hideShow == true
              ? "customLoc  " + customClassName
              : "hide"
          }
        >
          <div style={{ display: "none" }}>
            <FieldGroupFF
              label={fieldLabel}
              name={DataElementGroup.id}
              className={customClassName + " hide"}
            >
              {sortedDataElements.map((field) => {
                return getFieldDetails(field.id, values);
              })}
            </FieldGroupFF>
          </div>

          <div>
            <label className="labelSelect">{fieldLabel}</label>
            <OnChange name={DataElementGroup.id}>
              {() => {
                if (formref.current) {
                  formref.current.change("forceRenderField", Math.random());
                }
              }}
            </OnChange>
            <Field name="forceRenderField" component="input" type="hidden" />
            <AsyncSelect
              key={forceRender}
              className="multiSelectDropdown"
              name={DataElementGroup.id}
              isMulti
              cacheOptions
              label={fieldLabel}
              loadOptions={loadOptions}
              defaultOptions={sortedDataElements.map((de) => ({
                label: de.displayName.includes("_")
                  ? de.displayName.split("_")[0]
                  : de.displayName,
                value: de.id,
              }))}
              placeholder="Search and select..."
              noOptionsMessage={() => "Search and select..."}
              value={
                selectedOptions.length > 0
                  ? selectedOptions.map((option) => ({
                      label: option.label.includes("_")
                        ? option.label.split("_")[0]
                        : option.label,
                      value: option.value,
                    }))
                  : null
              }
              onChange={(newSelectedOptions) => {
                const updatedSelections = newSelectedOptions || [];
                // Store only the selected values (IDs)
                values[DataElementGroup.id] = updatedSelections.map(
                  (option) => option.value
                );
                {
                  sortedDataElements.map((field) => {
                    if (values[DataElementGroup.id].includes(field.id)) {
                      form.change(field.id, true);
                    } else {
                      form.change(field.id, false);
                    }
                  });
                }
                setSelectedOptions([...updatedSelections]);
                setForceRender(true);
                // Manually force a re-render by updating state asynchronously
              }}
              classNamePrefix="custom-Asyncselect"
              styles={{
                control: (base) => ({
                  ...base,
                  maxHeight: "100px", // Prevents excessive height
                  overflowY: "auto", // Allows scrolling when too many options are selected
                  flexWrap: "wrap",
                }),
                multiValue: (base) => ({
                  ...base,
                  maxWidth: "100px", // Prevents long labels from breaking layout
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }),
              }}
            />
          </div>
        </Grid>
      );
    }
  }, [
    selectedOptions,
    validationResult,
    localStorage.getItem("locale"),
    values,
    values[DataElementGroup.id],
  ]);

  useEffect(() => {}, [forceRender]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function QrCodeScanner(props) {
  let fieldData = props.fieldData;

  const [fieldStructure, setFieldStructure] = useState(null);
  const [showScannner, setShowScannner] = useState(false);
  const [defaultValue, setDefaultValue] = useState(null);

  function qrErrorhandler() {
    setShowScannner(false);
  }

  function handleQRScan(data) {
    if (data) {
      setShowScannner(false);
      setDefaultValue(data);
    }
  }

  function closeQrSacnner() {
    setShowScannner(false);
  }
  function openCordovaQrScanner() {
    let that = this;
    window.cordova.plugins.barcodeScanner.scan(
      function (result) {
        handleQRScan(result.text);
      },
      function (error) {},
      {
        preferFrontCamera: false, // iOS and Android
        showFlipCameraButton: true, // iOS and Android
        showTorchButton: false, // iOS and Android
        torchOn: false, // Android, launch with the torch switched on (if available)
        prompt: "Place a barcode inside the scan area", // Android
        resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
        //formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
        //orientation : "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
        disableAnimations: true, // iOS
        disableSuccessBeep: false, // iOS
      }
    );
  }
  function openQrSacnner() {
    if (window.cordova) {
      openCordovaQrScanner();
    } else {
      setShowScannner(true);
    }
  }

  useEffect(() => {
    if (showScannner) {
      setFieldStructure(
        <Grid item xs={12} sm={4} md={4}>
          <div style={{ display: "none" }}>
            <Field
              name={fieldData.dataElement.id}
              label={getTranslatedLabels(fieldData.dataElement)}
              type={fieldData.dataElement.valueType}
              component={InputFieldFF}
              key={fieldData.dataElement.id}
              defaultValue={defaultValue}
            />
          </div>
          <div style={{ height: "200px", width: "200px" }}>
            <Html5QrcodePlugin
              fps={10}
              qrbox={200}
              disableFlip={false}
              qrCodeSuccessCallback={(e) => handleQRScan(e)}
            />
            <span onClick={() => closeQrSacnner()}>
              <FontAwesomeIcon icon={faTimes} />
            </span>
          </div>
        </Grid>
      );
    } else {
      setFieldStructure(
        <Grid item xs={12} sm={4} md={4}>
          <div style={{ display: "none" }}>
            <Field
              name={fieldData.dataElement.id}
              label={getTranslatedLabels(fieldData.dataElement)}
              type={fieldData.dataElement.valueType}
              component={InputFieldFF}
              key={fieldData.dataElement.id}
              defaultValue={defaultValue}
            />
          </div>
          <p className="qrIcon" onClick={() => openQrSacnner()}>
            <FontAwesomeIcon className="fa-3x" icon={faQrcode} />
          </p>
        </Grid>
      );
    }
  }, [showScannner, defaultValue, localStorage.getItem("locale")]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}
function ImageFieldConfig(props) {
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let customClassName = props.customClassName;
  let dataElementGroup = props.dataElementGroup;
  let currentStage = props.currentStage;
  const [fieldStructure, setFieldStructure] = useState(null);
  const [validationResult, setValidationResult] = useState(null);
  const [defaultValue, setDefaultValue] = useState(null);

  function fetchValidation() {
    const validationResult = Validator(
      fieldData.dataElement.id,
      fieldData,
      values,
      programRules,
      programRulesVariables,
      dataElementGroup
    );
    setValidationResult(validationResult);
  }

  useEffect(() => {
    fetchValidation();
  }, [values]);

  async function openFileChooser() {
    const file = await window.chooser.getFile();
    setDefaultValue(file);
  }
  useEffect(() => {
    if (validationResult != null) {
      if (window.cordova && !navigator.onLine) {
        if (defaultValue) {
          values[fieldData.dataElement.id] = [defaultValue];
        }
        setFieldStructure(
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            className={validationResult.hideShow == true ? "" : "hide"}
          >
            <div style={{ display: "none" }}>
              <Field
                name={fieldData.dataElement.id}
                label={
                  currentStage.description != "General Services" &&
                  currentStage.name != "NCDs Screening, Treatment and Linkages"
                    ? getTranslatedLabels(fieldData.dataElement)
                    : ""
                }
                type={fieldData.dataElement.valueType}
                component={InputFieldFF}
                key={fieldData.dataElement.id}
                defaultValue={defaultValue}
                value={""}
              />
            </div>
            <label className={customClassName}>
              {getTranslatedLabels(fieldData.dataElement)}
            </label>
            <p className="qrIcon" onClick={() => openFileChooser()}>
              <FontAwesomeIcon className="fa-3x" icon={faFileUpload} />
            </p>
            {defaultValue && defaultValue.name ? (
              <p className={defaultValue && defaultValue.name ? "" : "hide"}>
                {defaultValue && defaultValue.name ? defaultValue.name : ""}
              </p>
            ) : values[fieldData.dataElement.id] &&
              values[fieldData.dataElement.id].includes("RTMUPLOADS") ? (
              <p className={values[fieldData.dataElement.id] ? "" : "hide"}>
                {values[fieldData.dataElement.id]
                  ? values[fieldData.dataElement.id].split("RTMUPLOADS/")
                    ? values[fieldData.dataElement.id].split("RTMUPLOADS/")[1]
                    : ""
                  : ""}
              </p>
            ) : (
              <p className={values[fieldData.dataElement.id] ? "" : "hide"}>
                {values[fieldData.dataElement.id]
                  ? values[fieldData.dataElement.id]
                  : ""}
              </p>
            )}
          </Grid>
        );
      } else {
        setFieldStructure(
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            className={validationResult.hideShow == true ? "" : "hide"}
          >
            <Field
              name={fieldData.dataElement.id}
              label={
                currentStage.description != "General Services" &&
                currentStage.name != "NCDs Screening, Treatment and Linkages"
                  ? getTranslatedLabels(fieldData.dataElement)
                  : ""
              }
              component={FileInputFieldFF}
              key={fieldData.dataElement.id}
              required={
                fieldData.compulsory && validationResult.hideShow == true
                  ? true
                  : false
              }
              value={[]}
              accept=".pdf, image/*"
              className={customClassName}
              //onChange={handleChange.bind(this)}
              //validate={composeValidators(required, URLCheck)}
            />
          </Grid>
        );
      }
    }
  }, [validationResult, defaultValue, localStorage.getItem("locale")]);

  return <>{fieldStructure != null ? fieldStructure : <> </>}</>;
}

function CreateField(props) {
  // console.log("props", props);
  let fieldData = props.fieldData;
  let programRules = props.programRules;
  let programRulesVariables = props.programRulesVariables;
  let values = props.values;
  let programData = props.programData;
  let dataElementGroup = props.dataElementGroup;
  let stages = props.stages;
  let currentStage = props.currentStage;
  let orgid = props.orgid;
  let OUM = OUMapping(values);
  let OUJSON = props.OUJSON;
  let customfieldobj = props.customfieldobj;
  let programBoDetails = props.programBoDetails;
  let customClassName = props.customClassName;
  let Configuration = props.Configuration;
  let hivarray = props.hivarray;
  const activeAccordion = props.activeAccordion;
  const hivConditions = props.hivConditions;
  const hivBehavioural = props.hivBehavioural;
  let AllHIVConditionCheck = props.AllHIVConditionCheck;
  let symptomsReferralID = null;
  let formref = props.formRef;
  let dateDependencies = props.dateDependencies;
  try {
    if (dataElementGroup && dataElementGroup.length > 0) {
      let dEID = dataElementGroup.filter(
        (obj) =>
          obj.displayName == customfieldobj.symptomsDisplayName &&
          obj.description &&
          obj.description ==
            "Currently are you experiencing any of the following symptoms"
      );
      if (dEID && dEID.length > 0) {
        symptomsReferralID = dEID[0].id;
      }
    }
  } catch (e) {}

  let rules = {
    programRule: props.programRules,
    programRuleVariable: props.programRulesVariables,
  };

  function checkFieldType() {
    let checkUnique = false;
    if (
      fieldData.dataElement.attributeValues.length > 0 &&
      fieldData.dataElement.attributeValues[0].attribute.displayName ==
        "unique" &&
      fieldData.dataElement.attributeValues[0].value
    ) {
      checkUnique = true;
    }

    switch (fieldData.dataElement.valueType) {
      case "TEXT":
        return fieldData.dataElement.unique ? (
          <DefaultValueField
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            dataElementGroup={dataElementGroup}
            customClassName={customClassName}
          />
        ) : checkUnique ? (
          <DefaultStageValueField
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            dataElementGroup={dataElementGroup}
            customClassName={customClassName}
          />
        ) : fieldData.dataElement.fieldMask == "Facility Referral" ||
          fieldData.dataElement.fieldMask == "Select HTC Referral Location" ? (
          <ReferalConfig
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            dataElementGroup={dataElementGroup}
            programData={programData}
            customfieldobj={customfieldobj}
            programBoDetails={programBoDetails}
            symptomsFID={symptomsReferralID}
            customClassName={customClassName}
            Configuration={Configuration}
          />
        ) : fieldData.renderType &&
          fieldData.renderType["DESKTOP"].type == "QR_CODE" ? (
          <QrCodeScanner
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            customClassName={customClassName}
          />
        ) : (
          <InputFieldConfig
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            dataElementGroup={dataElementGroup}
            OUJSON={OUJSON}
            programorgid={orgid}
            symptomsFID={symptomsReferralID}
            customfieldobj={customfieldobj}
            customClassName={customClassName}
            Configuration={Configuration}
            currentStage={currentStage}
            hivarray={hivarray}
            hivConditions={hivConditions}
            formref={formref}
            AllHIVConditionCheck={AllHIVConditionCheck}
          />
        );

      case "IMAGE":
      case "FILE_RESOURCE":
        return (
          <ImageFieldConfig
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            dataElementGroup={dataElementGroup}
            customClassName={customClassName}
            currentStage={currentStage}
          />
        );

      case "DATE":
        return (
          <DateFieldConfig
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            dataElementGroup={dataElementGroup}
            customClassName={customClassName}
            customfieldobj={customfieldobj}
            currentStage={currentStage}
            configuration={Configuration}
            hivarray={hivarray}
            hivConditions={hivConditions}
            hivBehavioural={hivBehavioural}
            activeAccordion={activeAccordion}
            AllHIVConditionCheck={AllHIVConditionCheck}
            dateDependencies={dateDependencies}
            formref={formref}
          />
        );

      case "AGE":
        return (
          <AgeFieldConfig
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            dataElementGroup={dataElementGroup}
            customClassName={customClassName}
          />
        );

      case "PHONE_NUMBER":
        return (
          <PhoneNumberFieldConfig
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            dataElementGroup={dataElementGroup}
            customClassName={customClassName}
          />
        );

      case "EMAIL":
        return (
          <EmailFieldConfig
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            dataElementGroup={dataElementGroup}
            customClassName={customClassName}
          />
        );
      case "BOOLEAN":
        //dataElementGroup
        if (
          dataElementGroup.filter(
            (obj) => obj.displayName == fieldData.dataElement.displayName
          ).length > 0
        ) {
          const filterDataElementGroup = dataElementGroup.filter(
            (obj) => obj.displayName == fieldData.dataElement.displayName
          )[0];

          return (
            <MultiSelectConfig
              fieldData={fieldData}
              programRules={programRules}
              programRulesVariables={programRulesVariables}
              values={values}
              DataElementGroup={filterDataElementGroup}
              dataElementGroup={dataElementGroup}
              programObj={programData}
              stages={stages}
              customfieldobj={customfieldobj}
              customClassName={customClassName}
              configuration={Configuration}
              formref={formref}
            />
          );
        } else {
          let ShowFieldFlag = true;
          dataElementGroup.map((DEG) => {
            DEG.dataElements.map((DataElements) => {
              if (DataElements.id == fieldData.dataElement.id) {
                ShowFieldFlag = false;
              }
            });
          });

          if (ShowFieldFlag) {
            return (
              <BooleanFieldConfig
                fieldData={fieldData}
                programRules={programRules}
                programRulesVariables={programRulesVariables}
                values={values}
                dataElementGroup={dataElementGroup}
                customClassName={customClassName}
                currentStage={currentStage}
              />
            );
          } else {
            return <> </>;
          }
        }

      case "TRUE_ONLY":
        if (
          dataElementGroup.filter(
            (obj) => obj.displayName == fieldData.dataElement.displayName
          ).length > 0
        ) {
          const filterDataElementGroup = dataElementGroup.filter(
            (obj) => obj.displayName == fieldData.dataElement.displayName
          )[0];

          return (
            <MultiSelectConfig
              fieldData={fieldData}
              programRules={programRules}
              programRulesVariables={programRulesVariables}
              values={values}
              DataElementGroup={filterDataElementGroup}
              programObj={programData}
              stages={stages}
              dataElementGroup={dataElementGroup}
              customClassName={customClassName}
              configuration={Configuration}
            />
          );
        } else {
          let ShowFieldFlag = true;
          dataElementGroup.map((DEG) => {
            DEG.dataElements.map((DataElements) => {
              if (DataElements.id == fieldData.dataElement.id) {
                ShowFieldFlag = false;
              }
            });
          });

          if (ShowFieldFlag) {
            return (
              <BooleanFieldConfig
                fieldData={fieldData}
                programRules={programRules}
                programRulesVariables={programRulesVariables}
                values={values}
                dataElementGroup={dataElementGroup}
                customClassName={customClassName}
              />
            );
          } else {
            return <> </>;
          }
        }

      case "TIME":
        return (
          <TimeFieldConfig
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            dataElementGroup={dataElementGroup}
            customClassName={customClassName}
          />
        );

      case "DATETIME":
        return (
          <DateTimeFieldConfig
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            dataElementGroup={dataElementGroup}
            customClassName={customClassName}
          />
        );

      case "INTEGER":
      case "INTEGER_POSITIVE":
      case "INTEGER_NEGATIVE":
      case "INTEGER_ZERO_OR_POSITIVE":
      case "NUMBER":
        return (
          <IntegerConfig
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            dataElementGroup={dataElementGroup}
            customClassName={customClassName}
            currentStage={currentStage}
            configuration={Configuration}
            hivarray={hivarray}
            hivConditions={hivConditions}
            customfieldobj={customfieldobj}
          />
        );
      case "LONG_TEXT":
        return (
          <TextAreaConfig
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            dataElementGroup={dataElementGroup}
            customClassName={customClassName}
          />
        );

      case "USERNAME":
        return (
          <UserNameConfig
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            dataElementGroup={dataElementGroup}
            programorgid={orgid}
            customClassName={customClassName}
          />
        );

      case "URL":
        return (
          <URLConfig
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            dataElementGroup={dataElementGroup}
            customClassName={customClassName}
          />
        );

      case "ORGANISATION_UNIT":
        let optionsId = "";
        const childDropDown = JSON.parse(localStorage.getItem("childDropDown"));
        if (childDropDown != null) {
          const fieldOptionFilter = childDropDown.filter(
            (obj) => obj.fieldId == fieldData.dataElement.id
          );
          if (fieldOptionFilter.length > 0) {
            optionsId = fieldOptionFilter[0].value;
          }
        }

        const defaultValue = values[fieldData.dataElement.id];
        let defaultOption = {};
        if (defaultValue != undefined) {
          const meta = JSON.parse(localStorage.getItem("metaData"));
          const LocationFilter = programData.organisationUnits.filter(
            (OU) => OU.id == values[fieldData.dataElement.id]
          );
          //const locationName = LocationFilter.length > 0 ? LocationFilter[0].displayName : ""
          //const UserBOLocationFilter = userBO && userBO.organisationUnits ? userBO.organisationUnits.filter(OU => OU.id == values[fieldData.dataElement.id]) : []
          const OUJSONLocationFilter =
            OUJSON && OUJSON.organisationUnits
              ? OUJSON.organisationUnits.filter(
                  (OU) => OU.id == values[fieldData.dataElement.id]
                )
              : [];
          const locationName =
            LocationFilter.length > 0
              ? LocationFilter[0].displayName
              : OUJSONLocationFilter.length > 0
              ? OUJSONLocationFilter[0].displayName
              : "";
          defaultOption = {
            id: values[fieldData.dataElement.id],
            label: locationName,
            value: values[fieldData.dataElement.id],
          };

          if (OUM[fieldData.dataElement.id] != undefined) {
            if (OUM[fieldData.dataElement.id].parent != "") {
              optionsId = values[OUM[fieldData.dataElement.id].parent];
            }
          }
        }
        return (
          <HandleOUOptions
            fieldData={fieldData}
            programRules={programRules}
            programRulesVariables={programRulesVariables}
            values={values}
            programData={programData}
            options={optionsId}
            defaultOption={defaultOption}
            OUJSON={OUJSON}
            customClassName={customClassName}
            customfieldobj={customfieldobj}
            hivarray={hivarray}
            hivConditions={hivConditions}
            AllHIVConditionCheck={AllHIVConditionCheck}
          />
        );
    }
  }

  return <>{checkFieldType()}</>;
}

export default CreateField;
